<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>

<div [class.isPrinting]="printService.isPrinting">
  <div class="job-posts placements agreements margin-top-service-30px top-link">
    <div class="card my-profile-form skillassest-form">



    </div>
    <div class="card-body padding-top padding-left-0px padding-right-0px">
      <div class="row">
        <div class="col-md-3 padding-right-0px colmd3">
          <div class="position-fixed-scans border-right2 padding-right-5px height-100pe">
            <div class="card height-100pe">

              <div class="card-header wh-header header3 padding-right-0px bk-color-light padding-bottom-0px border-bottom-0">
                <div class="row margin-top10px margin-left-20px  nav-link-hand">
                  <div class="col-md-10 padding-left-0px">
                    <label class="wh-header font-weight-normal card-title-schedule-bl border-radius-4px padding-top-0px padding-left-7px padding-bottom-0px margin-bottom-0px bk-color-light">
                      Embryo Transfer
                    </label>
                  </div>


                  <!--<div class=" col-md-2 padding-left-0px col-sm-4 text-align-right padding-right-10px">

                    <label for="diaplayName " class="font-size-15px margin-top-5px margin-bottom-0px">Date</label>
                  </div>-->


                  <div class="col-md-1">
                    <a class="nav-link-hand margin-top-auto margin-bottom margin-left-auto" title="Back To Ivf Bench" (click)="BackTodashboard()"><i class="fas fa-angle-double-left font-size-19px margin-top-5px"></i></a>
                  </div>
                  <!--<a class="nav-link-hand margin-top-auto margin-bottom margin-left-auto" title="Back To Services"
                  *ngIf="ShowIcon"><i class="fas fa-angle-double-left font-size-19px"></i></a>-->

                </div>




              </div>
              <div class="card-body padding-top-0px padding-left-0px padding-right-0px bk-color-light padding-right-0px padding-bottom-0px">
                <div class="row border-top margin-right-0px margin-left-0px">
                  <div class="col-md-5 col-sm-4 padding-right-0px my-profile-form margin-left-10px">
                    <div class="date-form margin-top-5px form-group margin-bottom-0px">
                      <input class="form-control" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
                             name="SelectedFromDate" [(ngModel)]="SelectedFromDate" (ngModelChange)="dataChanged($event)" ngbDatepicker #d="ngbDatepicker">

                      <a (click)="d.toggle()" class="nav-link-hand">
                        <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                      </a>

                    </div>



                  </div>
                  <div class="col-md-1 " (click)="DecrementDate()">
                    <a title="Previous" class="nav-link-hand">
                      <i class="fas fa-caret-left margin-top-10 font-size-20px color-secondary-hover"></i>
                    </a>
                  </div>
                  <div class="col-md-1 padding-left-0px padding-right-0px" (click)="IncrementDate()">
                    <a title="Next" class="nav-link-hand">
                      <i class="fas fa-caret-right margin-top-10 font-size-20px color-secondary-hover"></i>
                    </a>
                  </div>
                </div>
                <div class="row    margin-right-0px margin-left-0px">
                  <div class="col-md-11 margin-bottom-10px margin-top-10 margin-left-10px padding-right-0px padding-left-10px">
                    <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
                    <!--<input type="search"  [title]="searchTitle"  (change)="criteriaChange($event)" class="form-control padding-bottom-2px width-230px margin-top-10 margin-bottom-10px" placeholder="Search....">-->
                  </div>
                  <div class="col-md-2" hidden>
                    <button type="button" class="btn btn-primary btn-sm" tooltip="Add" hidden><i class="fas fa-plus nav-link-hand"></i></button>
                  </div>
                  <div class="col-md-1 padding-left-8px" hidden>
                    <a class="nav-link-hand education-navlink" tooltip="Edit">
                      <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
                    </a>

                  </div>
                  <div class="col-md-1 padding-left-8px" hidden>
                    <a class="nav-link-hand education-navlink" tooltip="Delete">
                      <span class="badge font-size-14">
                        <i class="far fa-trash-alt"></i>
                      </span>
                    </a>
                  </div>

                </div>

                <div>
                  <div class="chatsd product-chart-wrapper product-chat-width-97 agreement-chart-wrapper ps scroll padding-lrt " data-ps-id="dfsfsde">
                    <div *ngIf="isRequesting">
                      <div class="loader-text">
                        <div class="loader-text2">

                          <div class="lds-facebook">
                            <div></div>
                            <div></div>
                            <div></div>
                          </div>
                          <div class="margin-top-20px margin-left-5px">
                            <label class="margin-bottom-0px font-size-12px"> Please Wait...</label>
                          </div>
                          <!--Loading Please Wait...-->
                        </div>
                      </div>
                      <!--<div class="loadernew"></div>-->


                    </div>
                    <div *ngIf="!isRequesting">

                      <div class="row border-bottom row-for-scans margin-left16px nav-link-hand" (click)="Selectedpatient(l)" *ngFor="let l of pdata">
                        <div class="col-md-2 padding-left-0px margin-top-5px" (click)="Selectedpatient(l)">
                          <img class="user-image-circle-65px img2 margin-left-6px" [src]="l.OwnerPatientImageFile" onError="this.src='dummy.jpg';">



                        </div>
                        <div class="col-md-7 margin-top-5px padding-right-0px padding-left-10px">
                          <div class="row row-height-17px">
                            <div class="col-md-12">
                              <label class="margin-bottom-0px td-elipsis-scan font-size-14">{{l.OwnerName}}</label>
                            </div>
                          </div>
                          <div class="row row-height-17px">
                            <div class="col-md-12">
                              <label class="font-size-12px margin-bottom-0px light-gray-new">{{l.OwnerAgeYears}} years,{{l.OwnerFormattedCode}}</label>
                            </div>
                          </div>
                          <div class="row row-height-17px">
                            <div class="col-md-4">
                              <label class="font-size-12px margin-bottom-0px light-gray-new">{{l.OwnerTelephone1}}</label>
                            </div>
                          </div>

                        </div>
                        <div class="col-md-3 padding-left-0px margin-top-5px">
                          <div class="text-align-center"><label class="font-size-12px">#{{l.CycleNo}}</label></div>
                          <div class="text-align-center">
                            <a data-toggle="tooltip" data-placement="bottom" title="Completed" *ngIf="l.ActivityStatus=='Completed'">

                              <i class="fas fa-check-circle color-icon-completed font-size-16px">
                              </i>
                            </a>
                            <a data-toggle="tooltip" data-placement="bottom" title="Initiated" *ngIf="l.ActivityStatus=='Initiated'">

                              <i class="fas fa-check-circle color-gray font-size-16px">
                              </i>
                            </a>
                          </div>
                          <!--<div class="text-align-center"><label class="font-size-12px">{{l.LastUpdatedTime | date: 'hh:mm a'}}</label></div>-->
                        </div>
                      </div>
                    </div>
                    <!--<div class="row border-bottom row-for-scans margin-left16px nav-link-hand" (click)="Selectedpatient()">
                      <div class="col-md-2 padding-left-0px margin-top-5px" (click)="Selectedpatient()">
                        <img class="user-image-circle-65px img2 margin-left-6px" src="dummy.jpg">



                      </div>
                      <div class="col-md-7 margin-top-5px padding-right-0px padding-left-10px">
                        <div class="row row-height-17px">
                          <div class="col-md-12">
                            <label class="margin-bottom-0px">Ramya santhosh</label>
                          </div>
                        </div>
                        <div class="row row-height-17px">
                          <div class="col-md-12">
                            <label class="font-size-12px margin-bottom-0px light-gray-new">32 years,GGHOI/027</label>
                          </div>
                        </div>
                        <div class="row row-height-17px">
                          <div class="col-md-4">
                            <label class="font-size-12px margin-bottom-0px light-gray-new">9899989891</label>
                          </div>
                        </div>

                      </div>
                      <div class="col-md-3 padding-left-0px margin-top-5px">
                        <div class="text-align-center">
                          <i class="fas fa-check-circle color-icon-completed "></i>
                        </div>
                        <div class="text-align-center"><label class="font-size-12px">10:30</label></div>
                      </div>
                    </div>-->
                  </div>
                </div>

              </div>

            </div>
          </div>
        </div>

        <div class="col-md-6 padding-left-17px padding-right-8px" *ngIf="ScanDetails">

          <div class="row">
            <div class="col-md-12 padding-left-0px">
              <div class="card">
                <div class="card-header wh-header border-bottom padding-left-5px padding-right-0px">
                  <div class="row">
                    <div class="col-md-1 ">
                      <!--<img class=" margin-left-6px image-width-scans" [src]="SelectedpatientDetails.RecepientPatientImageFile" src="dummy.jpg">-->
                      <img class=" margin-left-6px image-width-scans" [src]="SelectedpatientDetails.RecepientPatientImageFile" onError="this.src='dummy.jpg';">
                    </div>
                    <div class="col-md-4 margin-left-18">
                      <div class="row row-height-17px margin-left-0px">
                        <label class="margin-bottom-0px font-weight-normal color-secondary">{{SelectedpatientDetails.RecepientName}} </label>
                      </div>
                      <!--<div class="row row-height-17px margin-left-0px" *ngIf="SelectedpatientDetails.EggSourceType=='DONOR' || SelectedpatientDetails.EggSourceType=='Donor'">
                        <div class="col-md-12 white-space-nowrap padding-left-0px padding-right-0px">
                          <label class="margin-bottom-0px font-weight-normal  font-size-12px color-owner">(of : {{SelectedpatientDetails.OwnerName}}) </label>
                        </div>
                      </div>-->

                      <div class="row row-height-17px margin-left-0px" *ngIf="ReceipentMember">
                        <div class="col-md-12 white-space-nowrap padding-left-0px padding-right-0px">
                          <label class="margin-bottom-0px font-weight-normal  font-size-12px color-owner">(of : {{ReceipentMember.MemberDisplayName}}) </label>
                        </div>
                      </div>

                      <!--<div class="row row-height-17px margin-left-0px" *ngFor="let l of CurrentIvfCycleMembersListController">
                        <div class="col-md-12 white-space-nowrap padding-left-0px padding-right-0px" *ngIf="l.MemberType=='Recepient'">
                          <label class="margin-bottom-0px font-weight-normal  font-size-12px color-owner">(of : {{l.MemberDisplayName}}) </label>
                        </div>
                      </div>-->

                      <div class="row row-height-17px">
                        <div class="col-md-12">
                          <label class="font-size-12px margin-bottom-0px font-weight-normal">{{SelectedpatientDetails.RecepientAgeYears}},{{SelectedpatientDetails.RecepientFormattedCode}}</label>
                        </div>
                      </div>
                      <div class="row row-height-17px">
                        <div class="col-md-4">
                          <label class="font-size-12px margin-bottom-0px font-weight-normal">{{SelectedpatientDetails.RecepientTelephone1}}</label>
                        </div>
                      </div>
                      <div class="row row-height-17px">
                        <div class="col-md-3">
                          <label class="font-size-12px margin-bottom-0px font-weight-normal">Cycle#{{SelectedpatientDetails.CycleNo}},</label>
                        </div>
                        <div class="col-md-9 padding-left-6px">
                          <label class="font-size-12px margin-bottom-0px font-weight-normal">Start Date: {{SelectedpatientDetails.ProtocolStartDate | date:'MMM-dd-yyyy'}}</label>
                        </div>

                      </div>
                    </div>
                    <div class="col-md-6 padding-right-0px">
                      <!--<div class="row font-size-12px">
                        <div class="col-md-6 margin-left-auto text-align-right padding-right-10px">
                          <label class="font-weight-normal font-size-12px margin-bottom-0px">Check In </label>
                        </div>:
                        <div class="col-md-3 padding-right-0px padding-left-10px" *ngIf="EmbryoTransferData2">
                          <label class="font-weight-normal font-size-12px margin-bottom-0px">{{EmbryoTransferData2.LastUpdatedTime | date: 'hh:mm a'}}</label>
                        </div>
                      </div>-->
                      <div class="row font-size-12px">
                        <div class="col-md-6 margin-left-auto text-align-right padding-right-10px">
                          <label class="font-weight-normal font-size-12px margin-bottom-0px">Status </label>
                        </div>:
                        <div class="col-md-3 padding-right-0px padding-left-10px" *ngIf="EmbryoTransferData2">
                          <label class="font-weight-normal font-size-12px margin-bottom-0px">{{EmbryoTransferData2.ActivityStatus}}</label>
                        </div>
                      </div>
                      <div class="row margin-right-0px" hidden>
                        <div class="Dsa1 margin-left-auto" *ngIf="DSADetails">
                          <label class="margin-bottom-0px font-weight-normal padding-top-6px padding-bottom-6px padding-right-6px font-size-14">{{DSADetails.DOC}}</label>
                        </div>
                        <div class="Dsa2" *ngIf="DSADetails">
                          <label class="margin-bottom-0px font-weight-normal padding-top-6px padding-bottom-6px padding-right-6px font-size-14">{{DSADetails.STIMULATION}}</label>
                        </div>
                        <div class="Dsa3" *ngIf="DSADetails">

                          <label class="margin-bottom-0px font-weight-normal padding-top-6px padding-bottom-6px padding-right-6px font-size-14">{{DSADetails.ANTAG}}</label>
                        </div>

                      </div>
                    </div>
                  </div>

                </div>
                <div class="card-body padding-right-0px padding-top-0px">
                  <div class="card">
                    <div class="card-header wh-header border-bottom-1px padding-top-6px padding-bottom-6px padding-left-0px padding-right-0px">
                      <div class="row nav-link-hand margin-right-0px" id="edit-link">
                        <div class="col-md-6 padding-right-0px">
                          <label class="margin-bottom-0px font-size-16px font-weight-normal">
                            Embryo Transfer
                          </label>
                        </div>
                        <div class="col-md-5  padding-right-0px">
                          <!--<div class="row float-right">
                            <div class="col-md-10 margin-top-3px padding-left-0px padding-right-0px" *ngIf="EmbryoTransferData2">
                              <a class="nav-link-hand patientreg-link margin-bottom-8px font-weight-normal display-edit" (click)="EmbryoTransfer()" title="Embryo Transfer Completed" *ngIf="EmbryoTransferData2.ActivityStatus !=='Completed'">Embryo Transfer Completed</a>
                            </div>
                            <div class="col-md-1" *ngIf="EmbryoTransferData2">
                              <a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printtransfer()" *ngIf="EmbryoTransferData2.ActivityStatus =='Completed'">
                                <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                              </a>
                            </div>
                            <div class="col-md-1" *ngIf="EmbryoTransferData2">
                              <a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printtransferdroplet()" *ngIf="EmbryoTransferData2.ActivityStatus =='Completed'">
                                <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                              </a>
                            </div>
                          </div>-->

                          <div class="row float-right" *ngIf="SelectedpatientDetails.GradingModel=='Well Culture' && SelectedpatientDetails.TCModelName!='Fet'">
                            <div class="col-md-10 margin-top-3px padding-left-0px" *ngIf="EmbryoTransferData2">
                              <a class="nav-link-hand patientreg-link  margin-bottom-8px font-weight-normal display-edit" (click)="EmbryoTransfer()" title="Embryo Transfer Completed" *ngIf="EmbryoTransferData2.ActivityStatus !=='Completed'">Embryo Transfer Completed</a>
                            </div>
                            <div class="col-md-1" *ngIf="EmbryoTransferData2">
                              <a class="nav-link-hand education-navlink data-color-new display-edit" title="print" (click)="printtransfer()" *ngIf="EmbryoTransferData2.ActivityStatus =='Completed'">
                                <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                              </a>
                            </div>
                          </div>

                          <div class="row" *ngIf="SelectedpatientDetails.GradingModel=='Droplet Culture' && SelectedpatientDetails.TCModelName!='Fet'">
                            <div class="col-md-10 margin-top-3px padding-left-0px padding-right-0px" *ngIf="EmbryoTransferData2">
                              <a class="nav-link-hand float-right patientreg-link padding-top-5px font-weight-normal display-edit" (click)="EmbryoTransfer()" title="Embryo Transfer Completed" *ngIf="EmbryoTransferData2.ActivityStatus !=='Completed'">Embryo Transfer Completed</a>
                            </div>
                            <div class="col-md-1" *ngIf="EmbryoTransferData2">
                              <a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printtransferdroplet()">
                                <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                              </a>
                              <!--<a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printtransferdroplet()" *ngIf="EmbryoTransferData2.ActivityStatus =='Completed'">
                                <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                              </a>-->
                            </div>

                          </div>


                        </div>

                      </div>
                    </div>
                    <div class=" padding-lrt " data-ps-id="dfsfsde">
                      <div class="card-body">
                        <div *ngIf="EmbryoTransFerEndInfo && EmbryoTransferData2">
                          <form class="form " novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
                            <div class="accordion margin-bottom-20px" id="accordionExample2" *ngIf="EmbryoTransferData2.ActivityStatus !=='Completed'">
                              <div class="card margin-bottom-5px">
                                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingTwo">
                                  <div class="row">
                                    <div class="col-md-4">
                                      <h5 class="mb-0 height-24px">
                                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                                          Schedule
                                        </button>
                                      </h5>
                                    </div>
                                    <div class="col-md-8 " *ngIf="EmbryoTransferData2">
                                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                      <button type="submit" [disabled]="DateOfBirth.errors?.required || ActivityTime.errors?.required" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="EmbryoTransferData2.ActivityStatus !=='Completed'">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                                    </div>
                                    <!--<div class="col-md-6">
                <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
              </div>-->
                                  </div>


                                </div>

                                <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo" data-parent="#accordionExample2">
                                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                                    <div class="card margin-bottom-0px">
                                      <!--<div class="card-header wh-header border-bottom-0px border-top-0 border-left-0 border-right-0 padding-bottom-0px">
                  <div class="row">
                    <div class="col-md-3">
                      <label class="font-weight-normal font-size-14">Add/Edit</label>
                    </div>
                    <div class="col-md-3 text-align-right">
                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                      <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                    </div>
                  </div>

                </div>-->
                                      <div class="card-body padding-top-0px padding-bottom-0px">


                                        <!--<div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">


                      <div class="row font-size-12px">
                        <div class="col-md-3  text-align-right padding-right-5px">
                          <label class="font-weight-normal font-size-12px margin-bottom-0px">Planned Time </label>
                        </div>:
                        <div class="col-md-3 padding-right-0px  padding-left-9px">
                          <label class="font-weight-normal font-size-12px margin-bottom-0px">{{EmbryoTransFerEndInfo.TransferDate}}</label>
                        </div>
                      </div>
                    </div>
                  </div>-->
                                        <div class="row my-profile-form">
                                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                            <div class="row">
                                              <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                                <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Actual Date </label>
                                              </div>


                                              <div class="col-md-3 padding-right-0px">

                                                <div class="date-form">
                                                  <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                                         name="dp1" [(ngModel)]="TransferEndDate" ngbDatepicker #d1="ngbDatepicker" #DateOfBirth="ngModel" required>
                                                  <small class="form-text text-danger"
                                                         *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
                                                  <a (click)="d1.toggle()" class="nav-link-hand">
                                                    <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                                  </a>

                                                </div>

                                              </div>

                                            </div>


                                          </div>
                                        </div>
                                        <div class="row my-profile-form">
                                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                            <div class="row">
                                              <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                                <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Actual Time </label>
                                              </div>


                                              <div class="col-md-3 padding-right-0px">

                                                <input type="time" class="form-control" id="EmbryoTransFerEndInfo.TransferEndTime" placeholder="Trigger Time"
                                                       [(ngModel)]="EmbryoTransFerEndInfo.TransferEndTime"
                                                       name="EmbryoTransFerEndInfo.TransferEndTime" pattern="^[\sa-zA-Z0-9,._\-?]*$" #ActivityTime="ngModel" required />

                                              </div>

                                            </div>


                                          </div>
                                        </div>




                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>

                        <div *ngIf="EmbryoTransFerEndInfo && EmbryoTransferData2">
                          <form class="form " novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
                            <div class="accordion margin-bottom-20px" id="accordionExample2" *ngIf="EmbryoTransferData2.ActivityStatus =='Completed'">
                              <div class="card margin-bottom-5px">
                                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingTwo">
                                  <div class="row">
                                    <div class="col-md-4">
                                      <h5 class="mb-0 height-24px">
                                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                                          Schedule
                                        </button>
                                      </h5>
                                    </div>
                                    <div class="col-md-8 " *ngIf="EmbryoTransferData2">
                                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                      <!--<button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="EmbryoTransferData2.ActivityStatus !=='Completed'">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>-->
                                    </div>

                                  </div>


                                </div>

                                <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo" data-parent="#accordionExample2">
                                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                                    <div class="card margin-bottom-0px">

                                      <div class="card-body padding-top-0px padding-bottom-0px">

                                        <div class="row my-profile-form">
                                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                            <div class="row">
                                              <div class="col-md-3 text-align-right margin-tg-auto ">
                                                <label for="diaplayName" class="margin-bottom-0px">Actual Date </label>
                                              </div>:


                                              <div class="col-md-3 margin-tg-auto">

                                                <!--<div class="date-form">
                            <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                   name="dp1" [(ngModel)]="TransferEndDate" ngbDatepicker #d1="ngbDatepicker" #DateOfBirth="ngModel">
                            <small class="form-text text-danger"
                                   *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
                            <a (click)="d1.toggle()" class="nav-link-hand">
                              <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                            </a>

                          </div>-->

                                                <label class="margin-bottom-0px ">{{EmbryoTransFerEndInfo.TransferEndDate | date:'MMM-dd-yyyy'}}</label>

                                              </div>

                                            </div>


                                          </div>
                                        </div>
                                        <div class="row my-profile-form">
                                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                            <div class="row">
                                              <div class="col-md-3 text-align-right margin-tg-auto ">
                                                <label for="diaplayName" class="margin-bottom-0px">Actual Time </label>
                                              </div>:


                                              <div class="col-md-3 margin-tg-auto">

                                                <!--<input type="time" class="form-control" id="EmbryoTransFerEndInfo.TransferEndTime" placeholder="Trigger Time"
                          [(ngModel)]="EmbryoTransFerEndInfo.TransferEndTime"
                          name="EmbryoTransFerEndInfo.TransferEndTime" pattern="^[\sa-zA-Z0-9,._\-?]*$" #ActivityTime="ngModel" />-->

                                                <label class="margin-bottom-0px ">{{EmbryoTransFerEndInfo.TransferEndTime| slice:11}}</label>

                                              </div>

                                            </div>


                                          </div>
                                        </div>




                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>

                        <div *ngIf="EmbryoTransFerEndInfo && EmbryoTransferData2">
                          <form class="form " novalidate="" (ngSubmit)="onSubmitTeam()" #f2="ngForm">
                            <div class="accordion margin-bottom-20px" id="accordionExample3" *ngIf="EmbryoTransferData2.ActivityStatus !=='Completed'">
                              <div class="card margin-bottom-5px">
                                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingThree">
                                  <div class="row">
                                    <div class="col-md-4">
                                      <h5 class="mb-0 height-24px">
                                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseThree" aria-expanded="true" aria-controls="collapseThree">
                                          Team
                                        </button>
                                      </h5>
                                    </div>
                                    <div class="col-md-8 " *ngIf="EmbryoTransferData2">
                                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                      <button type="submit" [disabled]="EmbryoTransFerEndInfo.Surgeon==0 || EmbryoTransFerEndInfo.AsstSurgeon==0 || EmbryoTransFerEndInfo.Embryologist==0 || EmbryoTransFerEndInfo.Anesthesiologist==0" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="EmbryoTransferData2.ActivityStatus !=='Completed'">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                                    </div>
                                    <!--<div class="col-md-6">
                <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
              </div>-->
                                  </div>


                                </div>

                                <div id="collapseThree" class="collapse show" aria-labelledby="headingThree" data-parent="#accordionExample3">
                                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                                    <div class="card margin-bottom-0px">
                                      <!--<div class="card-header wh-header border-bottom-0px border-top-0 border-left-0 border-right-0 padding-bottom-0px">
                  <div class="row">
                    <div class="col-md-3">
                      <label class="font-weight-normal font-size-14">Add/Edit</label>
                    </div>
                    <div class="col-md-3 text-align-right">
                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                      <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                    </div>
                  </div>

                </div>-->
                                      <div class="card-body padding-top-0px padding-bottom-0px">

                                        <div class="row my-profile-form">
                                          <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                            <div class="row">
                                              <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                                <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Surgeon </label>
                                              </div>


                                              <div class="col-md-3">
                                                <CustomDataByRequestType RequestedType="SURGEON_LIST"
                                                                         id="EmbryoTransFerEndInfo.Surgeon" SelectedValue="EmbryoTransFerEndInfo.Surgeon"
                                                                         [(ngModel)]="EmbryoTransFerEndInfo.Surgeon" (keyChange)="onAssignedToActorCodesurgeon($event)"
                                                                         name="EmbryoTransFerEndInfo.Surgeon" required>
                                                </CustomDataByRequestType>
                                                <!--<CodeTypeValue CodeType="FNSTS">-->
                                                <!--id="CurrentEditCounsellingPalnRequest.FinancialStatus"
                          [(ngModel)]="CurrentEditCounsellingPalnRequest.FinancialStatus" SelectedValue="CurrentEditCounsellingPalnRequest.FinancialStatus"
                          name="CurrentEditCounsellingPalnRequest.FinancialStatus">-->
                                                <!--</CodeTypeValue>-->
                                                <!--<input type="text" class="form-control" placeholder="Endometrium Thickness">-->
                                                <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                          [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                          name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                          maxlength="100" required>-->
                                                <!--<small class="form-text text-danger"
                                 *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                          <small class="form-text text-danger"
                                 *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                              </div>

                                            </div>


                                          </div>
                                        </div>
                                        <div class="row my-profile-form">
                                          <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                            <div class="row">
                                              <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                                <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Asst.Surgeon </label>
                                              </div>


                                              <div class="col-md-3">
                                                <CustomDataByRequestType RequestedType="ASSISTANT_SURGEON_LIST"
                                                                         id="EmbryoTransFerEndInfo.AsstSurgeon" SelectedValue=""
                                                                         [(ngModel)]="EmbryoTransFerEndInfo.AsstSurgeon" (keyChange)="onAssignedToActorCodeAsstSurgeon($event)"
                                                                         name="EmbryoTransFerEndInfo.AsstSurgeon" required #sign1="ngModel">
                                                </CustomDataByRequestType>
                                                <!--<CodeTypeValue CodeType="FNSTS">-->
                                                <!--id="CurrentEditCounsellingPalnRequest.FinancialStatus"
                          [(ngModel)]="CurrentEditCounsellingPalnRequest.FinancialStatus" SelectedValue="CurrentEditCounsellingPalnRequest.FinancialStatus"
                          name="CurrentEditCounsellingPalnRequest.FinancialStatus">-->
                                                <!--</CodeTypeValue>-->
                                                <!--<input type="text" class="form-control" placeholder="Endometrium Thickness">-->
                                                <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                          [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                          name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                          maxlength="100" required>-->
                                                <!--<small class="form-text text-danger"
                                 *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                          <small class="form-text text-danger"
                                 *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                              </div>

                                            </div>


                                          </div>
                                        </div>
                                        <div class="row my-profile-form">
                                          <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                            <div class="row">
                                              <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                                <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Embryologist </label>
                                              </div>


                                              <div class="col-md-3">
                                                <CustomDataByRequestType RequestedType="EMBRYOLOGIST_LIST"
                                                                         id="EmbryoTransFerEndInfo.Embryologist" SelectedValue=""
                                                                         [(ngModel)]="EmbryoTransFerEndInfo.Embryologist" (keyChange)="onAssignedToActorCodeAsstSurgeon2($event)"
                                                                         name="EmbryoTransFerEndInfo.Embryologist" required>
                                                </CustomDataByRequestType>
                                                <!--<input type="text" class="form-control" placeholder="Endometrium Thickness">-->
                                                <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                          [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                          name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                          maxlength="100" required>-->
                                                <!--<small class="form-text text-danger"
                                 *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                          <small class="form-text text-danger"
                                 *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                              </div>

                                            </div>


                                          </div>
                                        </div>
                                        <div class="row my-profile-form">
                                          <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                            <div class="row">
                                              <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                                <label for="diaplayName" class="font-size-12px margin-bottom-0px">Anaesthesiologist </label>
                                              </div>


                                              <div class="col-md-3">
                                                <CustomDataByRequestType RequestedType="ANAESTHETIST_LIST"
                                                                         id="EmbryoTransFerEndInfo.Anesthesiologist" SelectedValue="EmbryoTransFerEndInfo.Anesthesiologist"
                                                                         [(ngModel)]="EmbryoTransFerEndInfo.Anesthesiologist" (keyChange)="onAssignedToActorCodeAnaesthetist($event)"
                                                                         name="EmbryoTransFerEndInfo.Anesthesiologist">
                                                </CustomDataByRequestType>
                                                <!--<input type="text" class="form-control" placeholder="Endometrium Thickness">-->
                                                <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                          [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                          name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                          maxlength="100" required>-->
                                                <!--<small class="form-text text-danger"
                                 *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                          <small class="form-text text-danger"
                                 *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                              </div>

                                            </div>


                                          </div>
                                        </div>
                                        <div class="row my-profile-form">
                                          <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                            <div class="row">
                                              <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                                <label for="diaplayName" class="font-size-12px margin-bottom-0px">Anaesthesia </label>
                                              </div>


                                              <div class="col-md-3">
                                                <CodeTypeValue CodeType="IVFAT"
                                                               id="EmbryoTransFerEndInfo.AnaesthesiaType"
                                                               [(ngModel)]="EmbryoTransFerEndInfo.AnaesthesiaType" SelectedValue="EmbryoTransFerEndInfo.AnaesthesiaType"
                                                               name="EmbryoTransFerEndInfo.AnaesthesiaType">
                                                </CodeTypeValue>
                                                <!--<input type="text" class="form-control" placeholder="Endometrium Thickness">-->
                                                <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                          [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                          name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                          maxlength="100" required>-->
                                                <!--<small class="form-text text-danger"
                                 *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                          <small class="form-text text-danger"
                                 *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                              </div>

                                            </div>


                                          </div>
                                        </div>

                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>

                        <div *ngIf="EmbryoTransFerEndInfo && EmbryoTransferData2">
                          <form class="form " novalidate="" (ngSubmit)="onSubmitTeam()" #f="ngForm">
                            <div class="accordion margin-bottom-20px" id="accordionExample3" *ngIf="EmbryoTransferData2.ActivityStatus =='Completed'">
                              <div class="card margin-bottom-5px">
                                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingThree">
                                  <div class="row">
                                    <div class="col-md-4">
                                      <h5 class="mb-0 height-24px">
                                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseThree" aria-expanded="true" aria-controls="collapseThree">
                                          Team
                                        </button>
                                      </h5>
                                    </div>
                                    <div class="col-md-8 " *ngIf="EmbryoTransferData2">
                                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                      <!--<button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="EmbryoTransferData2.ActivityStatus !=='Completed'">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>-->
                                    </div>

                                  </div>


                                </div>

                                <div id="collapseThree" class="collapse show" aria-labelledby="headingThree" data-parent="#accordionExample3">
                                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                                    <div class="card margin-bottom-0px">

                                      <div class="card-body padding-top-0px padding-bottom-0px">

                                        <div class="row my-profile-form">
                                          <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                            <div class="row">
                                              <div class="col-md-3 text-align-right margin-tg-auto ">
                                                <label for="diaplayName" class="margin-bottom-0px">Surgeon </label>
                                              </div>:


                                              <div class="col-md-3 margin-tg-auto">
                                                <!--<CustomDataByRequestType RequestedType="SURGEON_LIST"
                                                   id="EmbryoTransFerEndInfo.Surgeon" SelectedValue="EmbryoTransFerEndInfo.Surgeon"
                                                   [(ngModel)]="EmbryoTransFerEndInfo.Surgeon" (keyChange)="onAssignedToActorCodesurgeon($event)"
                                                   name="EmbryoTransFerEndInfo.Surgeon" required>
                          </CustomDataByRequestType>-->

                                                <label class="margin-bottom-0px">{{EmbryoTransFerEndInfo.SurgeonName}}</label>
                                              </div>

                                            </div>


                                          </div>
                                        </div>
                                        <div class="row my-profile-form">
                                          <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                            <div class="row">
                                              <div class="col-md-3 text-align-right margin-tg-auto ">
                                                <label for="diaplayName" class="margin-bottom-0px">Asst.Surgeon </label>
                                              </div>:


                                              <div class="col-md-3 margin-tg-auto">
                                                <!--<CustomDataByRequestType RequestedType="ASSISTANT_SURGEON_LIST"
                                                   id="EmbryoTransFerEndInfo.AsstSurgeon" SelectedValue="EmbryoTransFerEndInfo.AsstSurgeon"
                                                   [(ngModel)]="EmbryoTransFerEndInfo.AsstSurgeon" (keyChange)="onAssignedToActorCodeAsstSurgeon($event)"
                                                   name="EmbryoTransFerEndInfo.AsstSurgeon" required>
                          </CustomDataByRequestType>-->

                                                <label class="margin-bottom-0px">{{EmbryoTransFerEndInfo.AsstSurgeonName}}</label>

                                              </div>

                                            </div>


                                          </div>
                                        </div>
                                        <div class="row my-profile-form">
                                          <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                            <div class="row">
                                              <div class="col-md-3 text-align-right margin-tg-auto ">
                                                <label for="diaplayName" class="margin-bottom-0px">Embryologist </label>
                                              </div>:


                                              <div class="col-md-3 margin-tg-auto">
                                                <!--<CustomDataByRequestType RequestedType="ASSISTANT_SURGEON_LIST"
                                                   id="EmbryoTransFerEndInfo.Embryologist" SelectedValue=""
                                                   [(ngModel)]="EmbryoTransFerEndInfo.Embryologist" (keyChange)="onAssignedToActorCodeAsstSurgeon2($event)"
                                                   name="EmbryoTransFerEndInfo.Embryologist" required>
                          </CustomDataByRequestType>-->

                                                <label class="margin-bottom-0px">{{EmbryoTransFerEndInfo.EmbryologistName}}</label>
                                              </div>

                                            </div>


                                          </div>
                                        </div>
                                        <div class="row my-profile-form">
                                          <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                            <div class="row">
                                              <div class="col-md-3 text-align-right margin-tg-auto ">
                                                <label for="diaplayName" class="margin-bottom-0px">Anaesthesiologist </label>
                                              </div>:


                                              <div class="col-md-3 margin-tg-auto">
                                                <!--<CustomDataByRequestType RequestedType="ANAESTHETIST_LIST"
                                                   id="EmbryoTransFerEndInfo.Anesthesiologist" SelectedValue="EmbryoTransFerEndInfo.Anesthesiologist"
                                                   [(ngModel)]="EmbryoTransFerEndInfo.Anesthesiologist" (keyChange)="onAssignedToActorCodeAnaesthetist($event)"
                                                   name="EmbryoTransFerEndInfo.Anesthesiologist" required>
                          </CustomDataByRequestType>-->

                                                <label class="margin-bottom-0px">{{EmbryoTransFerEndInfo.AnesthesiologistName}}</label>
                                              </div>

                                            </div>


                                          </div>
                                        </div>
                                        <div class="row my-profile-form">
                                          <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                            <div class="row">
                                              <div class="col-md-3 text-align-right margin-tg-auto ">
                                                <label for="diaplayName" class="margin-bottom-0px">Anaesthesia </label>
                                              </div>:


                                              <div class="col-md-3 margin-tg-auto">
                                                <!--<CodeTypeValue CodeType="IVFAT"
                                         id="EmbryoTransFerEndInfo.AnaesthesiaType"
                                         [(ngModel)]="EmbryoTransFerEndInfo.AnaesthesiaType" SelectedValue="EmbryoTransFerEndInfo.AnaesthesiaType"
                                         name="EmbryoTransFerEndInfo.AnaesthesiaType">
                          </CodeTypeValue>-->
                                                <label class="margin-bottom-0px">{{EmbryoTransFerEndInfo.AnaesthesiaType}}</label>
                                              </div>

                                            </div>


                                          </div>
                                        </div>

                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>

                        <div *ngIf="EmbryoTransFerEndInfo && EmbryoTransferData2">
                          <form class="form " novalidate="" (ngSubmit)="onSubmitTransferDetails()" #f="ngForm">
                            <div class="accordion margin-bottom-20px" id="accordionExample4" *ngIf="EmbryoTransferData2.ActivityStatus !=='Completed'">
                              <div class="card margin-bottom-5px">
                                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingFour">
                                  <div class="row">
                                    <div class="col-md-4">
                                      <h5 class="mb-0 height-24px">
                                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseFour" aria-expanded="true" aria-controls="collapseFour">
                                          Transfer Details
                                        </button>
                                      </h5>
                                    </div>
                                    <div class="col-md-8 " *ngIf="EmbryoTransferData2">
                                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                      <button type="submit" [disabled]="!f.valid" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="EmbryoTransferData2.ActivityStatus !=='Completed'">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                                    </div>
                                    <!--<div class="col-md-6">
                <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
              </div>-->
                                  </div>


                                </div>

                                <div id="collapseFour" class="collapse show" aria-labelledby="headingFour" data-parent="#accordionExample4">
                                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                                    <div class="card margin-bottom-0px">
                                      <!--<div class="card-header wh-header border-bottom-0px border-top-0 border-left-0 border-right-0 padding-bottom-0px">
                  <div class="row">
                    <div class="col-md-3">
                      <label class="font-weight-normal font-size-14">Add/Edit</label>
                    </div>
                    <div class="col-md-3 text-align-right">
                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                      <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                    </div>
                  </div>

                </div>-->
                                      <div class="card-body padding-top-0px padding-bottom-0px">


                                        <div class="card margin-bottom-0px border-all-1px">
                                          <div class="card-body padding-all-0px">
                                            <div class="row my-profile-form">
                                              <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                                <div class="row margin-top-5px">
                                                  <div class="col-md-3 padding-right-0px text-align-right margin-top-10 margin-bottom-auto ">
                                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">Type of Transfer </label>
                                                  </div>


                                                  <div class="col-md-3">
                                                    <CodeTypeValue CodeType="TOT"
                                                                   id="EmbryoTransFerEndInfo.TypeOfTransfer"
                                                                   [(ngModel)]="EmbryoTransFerEndInfo.TypeOfTransfer" SelectedValue="EmbryoTransFerEndInfo.TypeOfTransfer"
                                                                   name="EmbryoTransFerEndInfo.TypeOfTransfer">
                                                    </CodeTypeValue>
                                                    <!--<input type="text" class="form-control" placeholder="Endometrium Thickness">-->
                                                    <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                              [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                              name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                              maxlength="100" required>-->
                                                    <!--<small class="form-text text-danger"
                                     *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                              <small class="form-text text-danger"
                                     *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                                  </div>
                                                  <div class="col-md-2 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">Day Of Transfer </label>
                                                  </div>


                                                  <div class="col-md-3 padding-right-0px">
                                                    <CodeTypeValue CodeType="DOTRS"
                                                                   id="EmbryoTransFerEndInfo.DayOfTransfer"
                                                                   [(ngModel)]="EmbryoTransFerEndInfo.DayOfTransfer" SelectedValue="EmbryoTransFerEndInfo.DayOfTransfer"
                                                                   name="EmbryoTransFerEndInfo.DayOfTransfer">
                                                    </CodeTypeValue>


                                                  </div>


                                                </div>


                                              </div>
                                            </div>

                                            <div class="row my-profile-form">
                                              <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                                <div class="row">
                                                  <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">Culture Media Used </label>
                                                  </div>


                                                  <div class="col-md-3">
                                                    <CodeTypeValue CodeType="CULME"
                                                                   id="EmbryoTransFerEndInfo.CultureMedia"
                                                                   [(ngModel)]="EmbryoTransFerEndInfo.CultureMedia" SelectedValue="EmbryoTransFerEndInfo.CultureMedia"
                                                                   name="EmbryoTransFerEndInfo.CultureMedia">
                                                    </CodeTypeValue>
                                                    <!--<input type="text" class="form-control" placeholder="Endometrium Thickness">-->
                                                    <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                              [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                              name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                              maxlength="100" required>-->
                                                    <!--<small class="form-text text-danger"
                                     *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                              <small class="form-text text-danger"
                                     *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                                  </div>
                                                  <div class="col-md-2 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">Speculum Used </label>
                                                  </div>


                                                  <div class="col-md-3 padding-right-0px">
                                                    <CodeTypeValue CodeType="SPECU"
                                                                   id="EmbryoTransFerEndInfo.Speculum"
                                                                   [(ngModel)]="EmbryoTransFerEndInfo.Speculum" SelectedValue="EmbryoTransFerEndInfo.Speculum"
                                                                   name="EmbryoTransFerEndInfo.Speculum">
                                                    </CodeTypeValue>


                                                  </div>


                                                </div>


                                              </div>
                                            </div>

                                            <div class="row my-profile-form">
                                              <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                                <div class="row">
                                                  <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">Thawing Media Used </label>
                                                  </div>


                                                  <div class="col-md-3">
                                                    <CodeTypeValue CodeType="THWMD"
                                                                   id="EmbryoTransFerEndInfo.ThawingMedia"
                                                                   [(ngModel)]="EmbryoTransFerEndInfo.ThawingMedia" SelectedValue="EmbryoTransFerEndInfo.ThawingMedia"
                                                                   name="EmbryoTransFerEndInfo.ThawingMedia">
                                                    </CodeTypeValue>

                                                  </div>
                                                  <div class="col-md-2 padding-right-0px text-align-right margin-top-auto margin-bottom-auto">
                                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">Method </label>
                                                  </div>


                                                  <div class="col-md-3 padding-right-0px">
                                                    <CodeTypeValue CodeType="TRNSM"
                                                                   id="EmbryoTransFerEndInfo.TransferMethod"
                                                                   [(ngModel)]="EmbryoTransFerEndInfo.TransferMethod" SelectedValue="EmbryoTransFerEndInfo.TransferMethod"
                                                                   name="EmbryoTransFerEndInfo.TransferMethod">
                                                    </CodeTypeValue>
                                                    <!--<input type="text" class="form-control" placeholder="Endometrium Thickness">-->
                                                    <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                              [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                              name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                              maxlength="100" required>-->
                                                    <!--<small class="form-text text-danger"
                                     *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                              <small class="form-text text-danger"
                                     *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                                  </div>

                                                </div>


                                              </div>
                                            </div>

                                            <div class="row my-profile-form">
                                              <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                                <div class="row">
                                                  <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">Catheter Type </label>
                                                  </div>


                                                  <div class="col-md-3">
                                                    <CodeTypeValue CodeType="CATUS"
                                                                   id="EmbryoTransFerEndInfo.CatheterType"
                                                                   [(ngModel)]="EmbryoTransFerEndInfo.CatheterType" SelectedValue="EmbryoTransFerEndInfo.CatheterType"
                                                                   name="EmbryoTransFerEndInfo.CatheterType">
                                                    </CodeTypeValue>

                                                  </div>
                                                  <div class="col-md-2 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">Catheter Used </label>
                                                  </div>


                                                  <div class="col-md-3 padding-right-0px">
                                                    <CodeTypeValue CodeType="CATTY"
                                                                   id="EmbryoTransFerEndInfo.Catheter"
                                                                   [(ngModel)]="EmbryoTransFerEndInfo.Catheter" SelectedValue="EmbryoTransFerEndInfo.Catheter"
                                                                   name="EmbryoTransFerEndInfo.Catheter">
                                                    </CodeTypeValue>
                                                    <!--<input type="text" class="form-control" placeholder="Endometrium Thickness">-->
                                                    <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                              [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                              name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                              maxlength="100" required>-->
                                                    <!--<small class="form-text text-danger"
                                     *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                              <small class="form-text text-danger"
                                     *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                                  </div>


                                                </div>


                                              </div>
                                            </div>

                                            <div class="row my-profile-form">
                                              <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                                <div class="row">
                                                  <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto padding-left-0px">
                                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">Media Cleaning of Cervical Canal </label>
                                                  </div>


                                                  <div class="col-md-3">
                                                    <CodeTypeValue CodeType="CERCL"
                                                                   id="EmbryoTransFerEndInfo.CervicalCleaning"
                                                                   [(ngModel)]="EmbryoTransFerEndInfo.CervicalCleaning" SelectedValue="EmbryoTransFerEndInfo.CervicalCleaning"
                                                                   name="EmbryoTransFerEndInfo.CervicalCleaning">
                                                    </CodeTypeValue>


                                                  </div>
                                                  <div class="col-md-2 padding-right-0px text-align-right margin-top-auto margin-bottom-auto">
                                                    <!--<label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Method </label>-->
                                                  </div>


                                                  <div class="col-md-3 padding-right-0px">
                                                    <!--<CodeTypeValue CodeType="TRNSM"
                                             id="EmbryoTransFerEndInfo.TransferMethod"
                                             [(ngModel)]="EmbryoTransFerEndInfo.TransferMethod" SelectedValue="EmbryoTransFerEndInfo.TransferMethod"
                                             name="EmbryoTransFerEndInfo.TransferMethod">
                              </CodeTypeValue>-->

                                                  </div>

                                                </div>


                                              </div>
                                            </div>

                                          </div>
                                        </div>
                                        <div class="card margin-bottom-0px border-all-1px margin-top-10">
                                          <div class="card-body padding-all-0px">
                                            <div class="row my-profile-form">
                                              <div class="form-group col-md-12 col-xs-12 margin-bottom-0px">
                                                <div class="row">
                                                  <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">Retained Embryos </label>
                                                  </div>


                                                  <div class="col-md-3">
                                                    <input type="checkbox" class="width-15px margin-top-10" [(ngModel)]="EmbryoTransFerEndInfo.HasRetainedEmbryos" name="EmbryoTransFerEndInfo.HasRetainedEmbryos">
                                                    <!--<CodeTypeValue CodeType="FNSTS"
                                             id="EmbryoTransFerEndInfo.HasRetainedEmbryos"
                                             [(ngModel)]="EmbryoTransFerEndInfo.HasRetainedEmbryos" SelectedValue="EmbryoTransFerEndInfo.HasRetainedEmbryos"
                                             name="EmbryoTransFerEndInfo.HasRetainedEmbryos">
                              </CodeTypeValue>-->
                                                    <!--<input type="text" class="form-control" placeholder="Endometrium Thickness">-->
                                                    <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                              [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                              name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                              maxlength="100" required>-->
                                                    <!--<small class="form-text text-danger"
                                     *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                              <small class="form-text text-danger"
                                     *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                                  </div>

                                                  <div class="col-md-2 padding-right-0px text-align-right margin-top-15px ">
                                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">Technique </label>
                                                  </div>


                                                  <div class="col-md-3 margin-top-10">
                                                    <CodeTypeValue CodeType="IVFAT"
                                                                   id="EmbryoTransFerEndInfo.Technique"
                                                                   [(ngModel)]="EmbryoTransFerEndInfo.Technique" SelectedValue="EmbryoTransFerEndInfo.Technique"
                                                                   name="EmbryoTransFerEndInfo.Technique">
                                                    </CodeTypeValue>


                                                  </div>

                                                  <div class="col-md-2 padding-right-0px text-align-right margin-top-auto margin-bottom-auto " hidden>
                                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Fragmentation </label>
                                                  </div>
                                                  <div class="col-md-1" hidden>
                                                    <!--<CodeTypeValue CodeType="FNSTS"
                                                 id="CurrentEditCounsellingPalnRequest.FinancialStatus"
                               [(ngModel)]="CurrentEditCounsellingPalnRequest.FinancialStatus" SelectedValue="CurrentEditCounsellingPalnRequest.FinancialStatus"
                              name="CurrentEditCounsellingPalnRequest.FinancialStatus">
                                                </CodeTypeValue>-->
                                                    <input type="checkbox" class="width-15px margin-top-10" [(ngModel)]="EmbryoTransFerEndInfo.HasFragmentation" name="EmbryoTransFerEndInfo.HasFragmentation">
                                                  </div>
                                                  <div class="col-md-1 padding-left-0px margin-top-3px padding-right-0px" *ngIf="EmbryoTransFerEndInfo.HasFragmentation" hidden>
                                                    <input type="number" class="form-control" placeholder="%"
                                                           id="EmbryoTransFerEndInfo.Fragmentation"
                                                           [(ngModel)]="EmbryoTransFerEndInfo.Fragmentation"
                                                           name="EmbryoTransFerEndInfo.Fragmentation" #Doctor="ngModel"
                                                           maxlength="100" required>

                                                    <!--<small class="form-text text-danger"
                                     *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                              <small class="form-text text-danger"
                                     *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                                  </div>
                                                </div>


                                              </div>
                                            </div>
                                            <div class="row my-profile-form">
                                              <div class="form-group col-md-12 col-xs-12 margin-bottom-0px">
                                                <div class="row">
                                                  <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">Stilette </label>
                                                  </div>


                                                  <div class="col-md-3">
                                                    <input type="checkbox" class="width-15px margin-top-10" [(ngModel)]="EmbryoTransFerEndInfo.HasStilette" name="EmbryoTransFerEndInfo.HasStilette">


                                                  </div>
                                                  <div class="col-md-2 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">Dilator </label>
                                                  </div>


                                                  <div class="col-md-3">
                                                    <input type="checkbox" class="width-15px margin-top-10" [(ngModel)]="EmbryoTransFerEndInfo.HasDilator" name="EmbryoTransFerEndInfo.HasStilette">


                                                  </div>

                                                </div>


                                              </div>
                                            </div>
                                            <div class="row my-profile-form">
                                              <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                                <div class="row">
                                                  <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">Cervical Mucus </label>
                                                  </div>


                                                  <div class="col-md-3">
                                                    <input type="checkbox" class="width-15px margin-top-10" [(ngModel)]="EmbryoTransFerEndInfo.CervicalMucus" name="EmbryoTransFerEndInfo.CervicalMucus">


                                                  </div>
                                                  <div class="col-md-2 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">Retransfer </label>
                                                  </div>


                                                  <div class="col-md-3">
                                                    <input type="checkbox" class="width-15px margin-top-10" [(ngModel)]="EmbryoTransFerEndInfo.HasRetransfer" name="EmbryoTransFerEndInfo.HasRetransfer">


                                                  </div>

                                                </div>


                                              </div>
                                            </div>

                                            <div class="row my-profile-form">
                                              <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                                <div class="row">
                                                  <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">Blood on Catheter </label>
                                                  </div>


                                                  <div class="col-md-3">
                                                    <input type="checkbox" class="width-15px margin-top-10" [(ngModel)]="EmbryoTransFerEndInfo.BloodOnCatheter" name="EmbryoTransFerEndInfo.BloodOnCatheter">


                                                  </div>
                                                  <div class="col-md-2 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">Embryo Transfer </label>
                                                  </div>


                                                  <div class="col-md-3">
                                                    <CodeTypeValue CodeType="IVFTP"
                                                                   id="EmbryoTransFerEndInfo.TransferType"
                                                                   [(ngModel)]="EmbryoTransFerEndInfo.TransferType" SelectedValue="EmbryoTransFerEndInfo.TransferType"
                                                                   name="EmbryoTransFerEndInfo.TransferType">
                                                    </CodeTypeValue>
                                                    <!--<input type="text" class="form-control" placeholder="Endometrium Thickness">-->
                                                    <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                              [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                              name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                              maxlength="100" required>-->
                                                    <!--<small class="form-text text-danger"
                                     *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                              <small class="form-text text-danger"
                                     *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                                  </div>
                                                  <!--<div class="col-md-2 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Retransfer </label>
                            </div>


                            <div class="col-md-3">
                              <input type="checkbox" class="width-15px margin-top-10" [(ngModel)]="EmbryoTransFerEndInfo.HasRetransfer" name="EmbryoTransFerEndInfo.HasRetransfer">


                            </div>-->
                                                </div>


                                              </div>
                                            </div>

                                            <!--<div class="row my-profile-form">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                          <div class="row">
                            <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Embryo Transfer </label>
                            </div>


                            <div class="col-md-3">
                              <CodeTypeValue CodeType="IVFTP"
                                             id="EmbryoTransFerEndInfo.TransferType"
                                             [(ngModel)]="EmbryoTransFerEndInfo.TransferType" SelectedValue="EmbryoTransFerEndInfo.TransferType"
                                             name="EmbryoTransFerEndInfo.TransferType">
                              </CodeTypeValue>


                            </div>

                          </div>


                        </div>
                      </div>-->
                                          </div>
                                        </div>


                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>

                        <div *ngIf="EmbryoTransFerEndInfo && EmbryoTransferData2">
                          <form class="form " novalidate="" (ngSubmit)="onSubmitTransferDetails()" #f="ngForm">
                            <div class="accordion margin-bottom-20px" id="accordionExample4" *ngIf="EmbryoTransferData2.ActivityStatus =='Completed'">
                              <div class="card margin-bottom-5px">
                                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingFour">
                                  <div class="row">
                                    <div class="col-md-4">
                                      <h5 class="mb-0 height-24px">
                                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseFour" aria-expanded="true" aria-controls="collapseFour">
                                          Transfer Details
                                        </button>
                                      </h5>
                                    </div>
                                    <div class="col-md-8 " *ngIf="EmbryoTransferData2">
                                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                      <!--<button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="EmbryoTransferData2.ActivityStatus !=='Completed'">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>-->
                                    </div>

                                  </div>


                                </div>

                                <div id="collapseFour" class="collapse show" aria-labelledby="headingFour" data-parent="#accordionExample4">
                                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                                    <div class="card margin-bottom-0px">

                                      <div class="card-body padding-top-0px padding-bottom-0px">


                                        <div class="card margin-bottom-0px border-all-1px">
                                          <div class="card-body padding-all-0px">
                                            <div class="row my-profile-form margin-top-10">
                                              <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                                <div class="row">
                                                  <div class="col-md-3 text-align-right margin-top-3px">
                                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">Type of Transfer </label>
                                                  </div>:


                                                  <div class="col-md-3 margin-top-3px">
                                                    <!--<CodeTypeValue CodeType="CULME"
                                             id="EmbryoTransFerEndInfo.CultureMedia"
                                             [(ngModel)]="EmbryoTransFerEndInfo.CultureMedia" SelectedValue="EmbryoTransFerEndInfo.CultureMedia"
                                             name="EmbryoTransFerEndInfo.CultureMedia">
                              </CodeTypeValue>-->

                                                    <label class="margin-bottom-0px font-size-12px ">{{EmbryoTransFerEndInfo.TypeOfTransfer}}</label>

                                                  </div>
                                                  <div class="col-md-2 text-align-right margin-top-3px">
                                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">Day Of Transfer </label>
                                                  </div>:


                                                  <div class="col-md-3 margin-top-3px">
                                                    <!--<CodeTypeValue CodeType="TRNSM"
                                             id="EmbryoTransFerEndInfo.TransferMethod"
                                             [(ngModel)]="EmbryoTransFerEndInfo.TransferMethod" SelectedValue="EmbryoTransFerEndInfo.TransferMethod"
                                             name="EmbryoTransFerEndInfo.TransferMethod">
                              </CodeTypeValue>-->

                                                    <label class="font-size-12px margin-bottom-0px">{{EmbryoTransFerEndInfo.DayOfTransfer}}</label>

                                                  </div>

                                                </div>


                                              </div>
                                            </div>
                                            <div class="row my-profile-form">
                                              <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                                <div class="row">
                                                  <div class="col-md-3 text-align-right margin-top-3px ">
                                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">Culture Media Used </label>
                                                  </div>:


                                                  <div class="col-md-3 margin-top-3px">
                                                    <!--<CodeTypeValue CodeType="CULME"
                                             id="EmbryoTransFerEndInfo.CultureMedia"
                                             [(ngModel)]="EmbryoTransFerEndInfo.CultureMedia" SelectedValue="EmbryoTransFerEndInfo.CultureMedia"
                                             name="EmbryoTransFerEndInfo.CultureMedia">
                              </CodeTypeValue>-->

                                                    <label class="margin-bottom-0px font-size-12px ">{{EmbryoTransFerEndInfo.CultureMedia}}</label>

                                                  </div>
                                                  <div class="col-md-2 text-align-right margin-top-auto margin-bottom-auto">
                                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">Speculum Used </label>
                                                  </div>:


                                                  <div class="col-md-3 margin-top-auto margin-bottom-auto">
                                                    <!--<CodeTypeValue CodeType="TRNSM"
                                             id="EmbryoTransFerEndInfo.TransferMethod"
                                             [(ngModel)]="EmbryoTransFerEndInfo.TransferMethod" SelectedValue="EmbryoTransFerEndInfo.TransferMethod"
                                             name="EmbryoTransFerEndInfo.TransferMethod">
                              </CodeTypeValue>-->

                                                    <label class="font-size-12px margin-bottom-0px">{{EmbryoTransFerEndInfo.Speculum}}</label>

                                                  </div>

                                                </div>


                                              </div>
                                            </div>

                                            <div class="row my-profile-form">
                                              <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                                <div class="row">
                                                  <div class="col-md-3 text-align-right margin-top-auto margin-bottom-auto ">
                                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">Thawing Media Used </label>
                                                  </div>:


                                                  <div class="col-md-3 margin-top-auto margin-bottom-auto">
                                                    <!--<CodeTypeValue CodeType="CULME"
                                             id="EmbryoTransFerEndInfo.CultureMedia"
                                             [(ngModel)]="EmbryoTransFerEndInfo.CultureMedia" SelectedValue="EmbryoTransFerEndInfo.CultureMedia"
                                             name="EmbryoTransFerEndInfo.CultureMedia">
                              </CodeTypeValue>-->

                                                    <label class="margin-bottom-0px font-size-12px ">{{EmbryoTransFerEndInfo.ThawingMedia}}</label>

                                                  </div>
                                                  <div class="col-md-2 text-align-right margin-top-auto margin-bottom-auto">
                                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">Method </label>
                                                  </div>:


                                                  <div class="col-md-3 margin-top-auto margin-bottom-auto">
                                                    <!--<CodeTypeValue CodeType="TRNSM"
                                             id="EmbryoTransFerEndInfo.TransferMethod"
                                             [(ngModel)]="EmbryoTransFerEndInfo.TransferMethod" SelectedValue="EmbryoTransFerEndInfo.TransferMethod"
                                             name="EmbryoTransFerEndInfo.TransferMethod">
                              </CodeTypeValue>-->

                                                    <label class="font-size-12px margin-bottom-0px">{{EmbryoTransFerEndInfo.TransferMethod}}</label>

                                                  </div>

                                                </div>


                                              </div>
                                            </div>

                                            <div class="row my-profile-form">
                                              <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                                <div class="row">
                                                  <div class="col-md-3 text-align-right margin-top-3px ">
                                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">Catheter Type </label>
                                                  </div>:


                                                  <div class="col-md-3 margin-top-3px">
                                                    <!--<CodeTypeValue CodeType="CATUS"
                                             id="EmbryoTransFerEndInfo.CatheterType"
                                             [(ngModel)]="EmbryoTransFerEndInfo.CatheterType" SelectedValue="EmbryoTransFerEndInfo.CatheterType"
                                             name="EmbryoTransFerEndInfo.CatheterType">
                              </CodeTypeValue>-->

                                                    <label class="font-size-12px margin-bottom-0px">{{EmbryoTransFerEndInfo.CatheterType}}</label>

                                                  </div>
                                                  <div class="col-md-2 text-align-right margin-top-auto margin-bottom-auto ">
                                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">Catheter Used </label>
                                                  </div>:


                                                  <div class="col-md-3 margin-top-auto margin-bottom-auto">
                                                    <!--<CodeTypeValue CodeType="CATTY"
                                             id="EmbryoTransFerEndInfo.Catheter"
                                             [(ngModel)]="EmbryoTransFerEndInfo.Catheter" SelectedValue="EmbryoTransFerEndInfo.Catheter"
                                             name="EmbryoTransFerEndInfo.Catheter">
                              </CodeTypeValue>-->

                                                    <label class="font-size-12px margin-bottom-0px">{{EmbryoTransFerEndInfo.Catheter}}</label>

                                                  </div>
                                                </div>


                                              </div>
                                            </div>

                                            <div class="row my-profile-form">
                                              <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                                <div class="row">
                                                  <div class="col-md-3 text-align-right margin-top-auto margin-bottom-auto ">
                                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">Media Cleaning of Cervical Canal </label>
                                                  </div>:


                                                  <div class="col-md-3 margin-top-auto margin-bottom-auto">
                                                    <!--<CodeTypeValue CodeType="SPECU"
                                             id="EmbryoTransFerEndInfo.Speculum"
                                             [(ngModel)]="EmbryoTransFerEndInfo.Speculum" SelectedValue="EmbryoTransFerEndInfo.Speculum"
                                             name="EmbryoTransFerEndInfo.Speculum">
                              </CodeTypeValue>-->

                                                    <label class="font-size-12px margin-bottom-0px">{{EmbryoTransFerEndInfo.CervicalCleaning}}</label>

                                                  </div>
                                                  <div class="col-md-2 text-align-right margin-tg-auto padding-left-0px">
                                                    <!--<label for="diaplayName" class="font-size-12px margin-bottom-0px">Media Cleaning of Cervical Canal </label>-->
                                                  </div>


                                                  <div class="col-md-3 margin-top-auto margin-bottom-auto">

                                                    <!--<label class="font-size-12px margin-bottom-0px">{{EmbryoTransFerEndInfo.CervicalCleaning}}</label>-->

                                                  </div>
                                                </div>


                                              </div>
                                            </div>

                                          </div>
                                        </div>
                                        <div class="card margin-bottom-0px border-all-1px margin-top-10">
                                          <div class="card-body padding-all-0px">
                                            <div class="row my-profile-form">
                                              <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                                <div class="row">
                                                  <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">Retained Embryos </label>
                                                  </div>


                                                  <div class="col-md-3">
                                                    <input type="checkbox" class="width-15px margin-top-10" [(ngModel)]="EmbryoTransFerEndInfo.HasRetainedEmbryos" name="EmbryoTransFerEndInfo.HasRetainedEmbryos">


                                                  </div>
                                                  <div class="col-md-2 padding-right-0px text-align-right margin-top-15px ">
                                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">Technique </label>
                                                  </div>


                                                  <div class="col-md-3 margin-top-15px">
                                                    <!--<CodeTypeValue CodeType="IVFAT"
                         id="EmbryoTransFerEndInfo.Technique"
                         [(ngModel)]="EmbryoTransFerEndInfo.Technique" SelectedValue="EmbryoTransFerEndInfo.Technique"
                         name="EmbryoTransFerEndInfo.Technique">
          </CodeTypeValue>-->

                                                    <label class="font-size-12px margin-bottom-0px">{{EmbryoTransFerEndInfo.Technique}}</label>

                                                  </div>
                                                  <div class="col-md-2 padding-right-0px text-align-right margin-top-auto margin-bottom-auto " hidden>
                                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">Fragmentation </label>
                                                  </div>
                                                  <div class="col-md-1" hidden>

                                                    <input type="checkbox" class="width-15px margin-top-10" [(ngModel)]="EmbryoTransFerEndInfo.HasFragmentation" name="EmbryoTransFerEndInfo.HasFragmentation">
                                                  </div>
                                                  <div class="col-md-1 padding-left-0px margin-top-auto margin-bottom-auto padding-right-0px" *ngIf="EmbryoTransFerEndInfo.HasFragmentation" hidden>
                                                    <!--<input type="number" class="form-control" placeholder="%"
          id="EmbryoTransFerEndInfo.Fragmentation"
          [(ngModel)]="EmbryoTransFerEndInfo.Fragmentation"
          name="EmbryoTransFerEndInfo.Fragmentation" #Doctor="ngModel"
          maxlength="100" required>-->

                                                    <label class="font-size-12px margin-bottom-0px">{{EmbryoTransFerEndInfo.Fragmentation}}</label>

                                                  </div>
                                                </div>


                                              </div>
                                            </div>
                                            <div class="row my-profile-form">
                                              <div class="form-group col-md-12 col-xs-12 margin-bottom-0px">
                                                <div class="row">
                                                  <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">Stilette </label>
                                                  </div>


                                                  <div class="col-md-3">
                                                    <input type="checkbox" class="width-15px margin-top-10" [(ngModel)]="EmbryoTransFerEndInfo.HasStilette" name="EmbryoTransFerEndInfo.HasStilette">


                                                  </div>
                                                  <div class="col-md-2 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">Dilator </label>
                                                  </div>


                                                  <div class="col-md-3">
                                                    <input type="checkbox" class="width-15px margin-top-10" [(ngModel)]="EmbryoTransFerEndInfo.HasDilator" name="EmbryoTransFerEndInfo.HasStilette">


                                                  </div>

                                                </div>


                                              </div>
                                            </div>
                                            <div class="row my-profile-form">
                                              <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                                <div class="row">
                                                  <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">Cervical Mucus </label>
                                                  </div>


                                                  <div class="col-md-3">
                                                    <input type="checkbox" class="width-15px margin-top-10" [(ngModel)]="EmbryoTransFerEndInfo.CervicalMucus" name="EmbryoTransFerEndInfo.CervicalMucus">


                                                  </div>
                                                  <div class="col-md-2 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">Retransfer </label>
                                                  </div>


                                                  <div class="col-md-3">
                                                    <input type="checkbox" class="width-15px margin-top-10" [(ngModel)]="EmbryoTransFerEndInfo.HasRetransfer" name="EmbryoTransFerEndInfo.HasRetransfer">


                                                  </div>

                                                </div>


                                              </div>
                                            </div>

                                            <div class="row my-profile-form">
                                              <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                                <div class="row">
                                                  <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">Blood on Catheter </label>
                                                  </div>


                                                  <div class="col-md-3">
                                                    <input type="checkbox" class="width-15px margin-top-10" [(ngModel)]="EmbryoTransFerEndInfo.BloodOnCatheter" name="EmbryoTransFerEndInfo.BloodOnCatheter">


                                                  </div>


                                                  <div class="col-md-2 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">Embryo Transfer </label>
                                                  </div>


                                                  <div class="col-md-3 margin-top-7px">
                                                    <!--<CodeTypeValue CodeType="IVFTP"
                         id="EmbryoTransFerEndInfo.TransferType"
                         [(ngModel)]="EmbryoTransFerEndInfo.TransferType" SelectedValue="EmbryoTransFerEndInfo.TransferType"
                         name="EmbryoTransFerEndInfo.TransferType">
          </CodeTypeValue>-->

                                                    <label class="font-size-12px margin-bottom-0px">{{EmbryoTransFerEndInfo.TransferType}}</label>

                                                  </div>
                                                </div>


                                              </div>
                                            </div>


                                          </div>
                                        </div>


                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>

                        <div class="row margin-left-0px margin-top-15px" *ngIf="SelectedpatientDetails.GradingModel=='Well Culture'">
                          <div class="col-md-12 padding-left-0px">
                            <div class="accordion margin-bottom-20px" id="accordionExample9">
                              <div class="card margin-bottom-5px">
                                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingnine">
                                  <div class="row">
                                    <div class="col-md-4">
                                      <h5 class="mb-0 height-24px">
                                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapsenine" aria-expanded="true" aria-controls="collapsenine">
                                          Embryo Grading
                                        </button>
                                      </h5>
                                    </div>
                                    <div class="col-md-8 ">
                                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                      <!--<button type="button"
                        class="btn  btn-sm drive-button3 background-primary border-all-secondary float-right" id="FileUpload" (click)="AddTests()"
                        name="upload" *ngIf="!SelectedpatientDetails.IsReadyForPickup">
                  <i class="fas fa-plus font-size-11"></i>
                </button>-->
                                      <!--<button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>-->
                                    </div>
                                    <!--<div class="col-md-6">
                <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
              </div>-->
                                  </div>


                                </div>

                                <div id="collapsenine" class="collapse show" aria-labelledby="headingnine" data-parent="#accordionExample9">
                                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                                    <div class="card margin-bottom-0px">
                                      <!--<div class="card-header wh-header border-bottom-0px border-top-0 border-left-0 border-right-0 padding-bottom-0px">
                  <div class="row">
                    <div class="col-md-3">
                      <label class="font-weight-normal font-size-14">Add/Edit</label>
                    </div>
                    <div class="col-md-3 text-align-right">
                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                      <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                    </div>
                  </div>

                </div>-->
                                      <div class="card-body padding-top-0px padding-bottom-0px">
                                        <div class="table-component">
                                          <div class="table-responsive">


                                            <table class="table table-striped margin-left-zero width-50-new">
                                              <thead class="">
                                                <tr>

                                                  <th class="min-width-0px padding-left-0px padding-right-0px padding-top-4px padding-bottom-4px font-size-12px">
                                                    S.No
                                                  </th>

                                                  <th class="padding-left-0px padding-right-0px padding-top-4px padding-bottom-4px font-size-12px">DOC</th>

                                                  <!--<th class="td-well-width-79px">
                              Well #
                            </th>

                            <th class="th-width-95px">Denuded</th>
                            <th>
                              Ins.Tech
                            </th>-->
                                                  <!--<th class="">
                              Day1
                            </th>
                            <th class="">
                              Day2
                            </th>
                            <th class="">
                              Day3
                            </th>

                            <th class="">
                              Day4
                            </th>

                            <th class="">
                              Day5
                            </th>
                            <th class="">
                              Day6
                            </th>-->
                                                  <th class="padding-left-0px padding-right-0px padding-top-4px padding-bottom-4px font-size-12px">Details</th>
                                                  <th class="padding-left-0px padding-right-0px padding-top-4px padding-bottom-4px font-size-12px"></th>

                                                  <th class="padding-left-0px padding-right-0px padding-top-4px padding-bottom-4px font-size-12px"> Is Transferred</th>


                                                </tr>
                                              </thead>

                                              <tbody class="table-body">
                                                <tr *ngFor="let l of CurrentSingleWellCultureByCycleCodeController;let i = index">

                                                  <td class="padding-top-0px padding-bottom-0px">{{i+1}}</td>
                                                  <td class="padding-top-0px padding-bottom-0px">{{GetMaxDOC(l)}}</td>
                                                  <td class="padding-top-0px padding-bottom-0px">
                                                    <div *ngIf="SelectedpatientDetails.GradingModel=='Well Culture'">Well # : {{l.WellNo}}</div>
                                                    <div *ngIf="SelectedpatientDetails.GradingModel=='Droplet Culture'">Number : </div>
                                                    <div>Ins.Tech : {{l.Technique}} </div>
                                                    <div>Denuded : {{l.OocyteQualityPost}}</div>
                                                  </td>



                                                  <td class="padding-top-0px padding-bottom-0px">

                                                    <div class="card border-all-1px nav-link-hand margin-bottom-0px">

                                                      <div class="card-body padding-right-0px padding-bottom-0px padding-top-0px padding-left-0px">

                                                        <div class="row margin-left-0px">
                                                          <div>
                                                            <label class="margin-left-3px">{{GetMaxGrade(l)}}</label>
                                                          </div>
                                                          <div>
                                                            <img class="border-radius-50p nav-link-hand margin-top-10" height="35px" width="35px" [src]="l.Image1" onError="this.src='dummy.jpg';">
                                                          </div>

                                                        </div>


                                                      </div>

                                                    </div>

                                                  </td>




                                                  <td class="padding-top-0px padding-bottom-0px  padding-right-0px ">
                                                    <!--<button (click)="SaveTransfered(l)" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new " *ngIf="!l.IsTransFerred">Confirm </button>-->
                                                    <button (click)="SaveTransfered(l)" class="btn actions-btn-prime font-size-13px" *ngIf="!l.IsTransFerred">Confirm </button>
                                                    <div class="row margin-left-0px margin-right-0px" *ngIf="l.IsTransFerred">
                                                      <div class="col-md-1 padding-left-4">
                                                        <i class="fas fa-check-circle color-icon-completed font-size-23px"></i>
                                                      </div>
                                                      <div class="col-md-10 padding-right-0px text-align-left">
                                                        <label class="margin-bottom-0px">Is Transferred</label>
                                                      </div>

                                                    </div>
                                                    <!--<div *ngIf="l.IsTransFerred">
                                <i class="fas fa-check-circle color-icon-completed font-size-23px"></i>
                                <label class="margin-bottom-0px">Is Transferred</label>
                              </div>-->
                                                    <!--<div class="row" *ngIf="l.IsTransFerred">

                                <div *ngIf="l.IsTransFerred"><i class="fas fa-check-circle color-icon-completed font-size-23px"></i></div>
                                <div *ngIf="l.IsTransFerred"><label class="margin-bottom-0px">Is Transferred</label></div>
                              </div>-->

                                                  </td>
                                                </tr>



                                              </tbody>

                                            </table>

                                          </div>
                                        </div>

                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                        <div class="row margin-left-0px margin-top-15px" *ngIf="SelectedpatientDetails.GradingModel=='Droplet Culture'">
                          <div class="col-md-12 padding-left-0px">
                            <div class="accordion margin-bottom-20px" id="accordionExample9">
                              <div class="card margin-bottom-5px">
                                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingnine">
                                  <div class="row">
                                    <div class="col-md-4">
                                      <h5 class="mb-0 height-24px">
                                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapsenine" aria-expanded="true" aria-controls="collapsenine">
                                          Embryo Grading
                                        </button>
                                      </h5>
                                    </div>
                                    <div class="col-md-8 " *ngIf="EmbryoTransferData2">
                                      <button type="button" (click)="Addactivity()"
                                              class="btn  btn-sm drive-button3 background-primary border-all-secondary float-right" id="FileUpload"
                                              name="upload" *ngIf="EmbryoTransferData2.ActivityStatus !=='Completed'">
                                        <i class="fas fa-plus font-size-11"></i>
                                      </button>
                                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>


                                    </div>

                                  </div>


                                </div>

                                <div id="collapsenine" class="collapse show" aria-labelledby="headingnine" data-parent="#accordionExample9">
                                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                                    <div class="card margin-bottom-0px">

                                      <div class="card-body padding-top-0px padding-bottom-0px">
                                        <div class="table-component">
                                          <div class="table-responsive">


                                            <table class="table table-striped margin-left-zero width-50-new">
                                              <thead class="">
                                                <tr>
                                                  <th class="padding-top-4px padding-bottom-4px font-size-12px padding-left-0px">DOC &amp; Date  </th>

                                                  <th class="white-space-preline padding-top-4px padding-bottom-4px font-size-12px"> Stage  </th>
                                                  <th class="min-width-0px padding-top-4px padding-bottom-4px font-size-12px white-space-preline">Straw#</th>
                                                  <th class="white-space-preline padding-top-4px padding-bottom-4px font-size-12px">Grade</th>
                                                  <th class="min-width-0px padding-top-4px padding-bottom-4px font-size-12px white-space-preline">Transfer Count</th>
                                                  <!--<th class="white-space-preline padding-top-4px padding-bottom-4px font-size-12px"> Is Transferred</th>-->
                                                </tr>
                                              </thead>

                                              <tbody class="table-body">
                                                <tr *ngFor="let l of CurrentIvfCycleEmbryoTransferredController">

                                                  <td class="padding-top-4px padding-bottom-4px padding-right-0px padding-left-0px">
                                                    <div>[{{l.DOC}}]</div>
                                                    <div class="font-size-11px">{{l.TimeStamp| date:'MMM-dd-yyyy'}}</div>
                                                  </td>
                                                  <td class="padding-top-0px padding-bottom-0px">
                                                    {{l.Cellstage}}
                                                  </td>
                                                  <td class="padding-top-0px padding-bottom-0px text-align-center">{{l.StrawNumber}}</td>
                                                  <td class="padding-top-0px padding-bottom-0px">{{l.Regrade1}}{{l.Regrade2}}</td>
                                                  <td class="padding-top-0px padding-bottom-0px text-align-center text-align-center">{{l.UsedCount}}</td>






                                                </tr>



                                              </tbody>

                                            </table>

                                          </div>
                                        </div>

                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                        <div class="row margin-left-0px margin-top-15px">
                          <div class="col-md-12 padding-left-0px">
                            <div class="accordion margin-bottom-20px" id="accordionExample5">
                              <div class="card margin-bottom-5px">
                                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingFive">
                                  <div class="row">
                                    <div class="col-md-4">
                                      <h5 class="mb-0 height-24px">
                                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseFive" aria-expanded="true" aria-controls="collapseFive">
                                          Procedures/Tests
                                        </button>
                                      </h5>
                                    </div>
                                    <div class="col-md-8 " *ngIf="EmbryoTransferData2">
                                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                      <button type="button"
                                              class="btn  btn-sm drive-button3 background-primary border-all-secondary float-right" id="FileUpload" (click)="AddTests()"
                                              name="upload" *ngIf="EmbryoTransferData2.ActivityStatus !=='Completed'">
                                        <i class="fas fa-plus font-size-11"></i>
                                      </button>
                                      <!--<button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>-->
                                    </div>
                                    <!--<div class="col-md-6">
                <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
              </div>-->
                                  </div>


                                </div>

                                <div id="collapseFive" class="collapse show" aria-labelledby="headingFive" data-parent="#accordionExample5">
                                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                                    <div class="card margin-bottom-0px">
                                      <!--<div class="card-header wh-header border-bottom-0px border-top-0 border-left-0 border-right-0 padding-bottom-0px">
                  <div class="row">
                    <div class="col-md-3">
                      <label class="font-weight-normal font-size-14">Add/Edit</label>
                    </div>
                    <div class="col-md-3 text-align-right">
                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                      <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                    </div>
                  </div>

                </div>-->
                                      <div class="card-body padding-top-0px padding-bottom-0px">
                                        <div class="row">
                                          <div class="col-lg-11 col-md-11 col-xs-11 padding-right-0px">
                                            <div class="table-component table-tests">
                                              <div class="table-responsive">


                                                <table class="table table-striped margin-left-zero width-50-new">

                                                  <tbody class="table-body">

                                                    <tr *ngFor="let l of CurrentIvfCycleTestByCodeController ; let RowIndex = index ">
                                                      <!--<td class="padding-top-4px padding-bottom-4px ">{{l.Date | date:'MMM-dd-yyyy'}}</td>
                                <td class="padding-top-4px padding-bottom-4px ">{{l.TestName}}</td>
                                <td class=" padding-top-4px padding-bottom-4px ">{{l.Comments}}</td>-->
                                                      <td class="padding-top-4px padding-bottom-4px padding-right-0px">{{RowIndex+1}}</td>
                                                      <td class="padding-top-4px padding-bottom-4px padding-left-0px">
                                                        <div class="height-16px">
                                                          <label class="font-size-14 margin-bottom-0px">{{l.TestName}}</label>
                                                        </div>
                                                        <div class="row-height-17px">
                                                          <label class="font-size-12px margin-bottom-0px">Result : {{l.Result}}{{l.ResultUnits}}</label>
                                                        </div>
                                                        <div class="row-height-17px">
                                                          <label class="font-size-12px margin-bottom-0px">{{l.Comments}}</label>
                                                        </div>
                                                      </td>
                                                      <td class="padding-top-4px padding-bottom-4px">
                                                        <!--<a class="nav-link-hand education-navlink margin-right-10px " title="Edit">
                                    <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
                                  </a>-->
                                                        <div class="test-icons float-right" *ngIf="EmbryoTransferData2">
                                                          <a (click)="delTEST(l)" title="Remove" *ngIf="EmbryoTransferData2.ActivityStatus !=='Completed'"><i class="fa fa-times color-Rejected delete-test-icon nav-link-hand"></i></a>
                                                          <a (click)="EditTest(l)" class="nav-link-hand education-navlink  color-Assign editicon edit-test-icon" title="Edit" *ngIf="EmbryoTransferData2.ActivityStatus !=='Completed'">
                                                            <span class="badge"><i class="fas fa-pencil-alt"></i></span>
                                                          </a>
                                                        </div>
                                                      </td>




                                                    </tr>

                                                  </tbody>
                                                </table>

                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>

                        <div class="row margin-left-0px margin-top-15px">
                          <div class="col-md-12 padding-left-0px">
                            <div class="accordion margin-bottom-20px" id="accordionExample6">
                              <div class="card margin-bottom-5px">
                                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingSix">
                                  <div class="row">
                                    <div class="col-md-4">
                                      <h5 class="mb-0 height-24px">
                                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseSix" aria-expanded="true" aria-controls="collapseSix">
                                          Medicines
                                        </button>
                                      </h5>
                                    </div>
                                    <div class="col-md-8 " *ngIf="EmbryoTransferData2">
                                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                      <button type="button"
                                              class="btn  btn-sm drive-button3 background-primary border-all-secondary float-right" id="FileUpload" (click)="AddMedicine()"
                                              name="upload" *ngIf="EmbryoTransferData2.ActivityStatus !=='Completed'">
                                        <i class="fas fa-plus font-size-11"></i>
                                      </button>
                                      <!--<button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>-->
                                    </div>
                                    <!--<div class="col-md-6">
                <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
              </div>-->
                                  </div>


                                </div>

                                <div id="collapseSix" class="collapse show" aria-labelledby="headingSix" data-parent="#accordionExample6">
                                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                                    <div class="card margin-bottom-0px">
                                      <!--<div class="card-header wh-header border-bottom-0px border-top-0 border-left-0 border-right-0 padding-bottom-0px">
                  <div class="row">
                    <div class="col-md-3">
                      <label class="font-weight-normal font-size-14">Add/Edit</label>
                    </div>
                    <div class="col-md-3 text-align-right">
                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                      <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                    </div>
                  </div>

                </div>-->
                                      <div class="card-body padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">
                                        <div class="col-lg-11 col-md-11 col-xs-11 col-11 padding-right-0px ">


                                          <div class="table-component">
                                            <div class="table-responsive">


                                              <table class="table table-striped margin-left-zero width-50-new">
                                                <!--<thead>
                                                              <tr>
                                                                <th class="font-weight-normal  background-primary padding-left-4 padding-right-4 th-width-40px padding-top-4px padding-bottom-4px"></th>
                                                                <th class="font-weight-normal  background-primary padding-left-4 padding-right-4 padding-top-4px padding-bottom-4px">

                                                                </th>

                                                                <th class="font-weight-normal  background-primary padding-left-4  padding-top-4px padding-bottom-4px">

                          </th>
                          <th class="font-weight-normal  background-primary padding-left-4  padding-top-4px padding-bottom-4px">

                          </th>
                          <th class="font-weight-normal  background-primary padding-left-4  padding-top-4px padding-bottom-4px">

                          </th>


                                                                <th class="font-weight-normal  background-primary padding-top-4px padding-bottom-4px">

                                                                </th>











                                                              </tr>
                                                            </thead>-->
                                                <tbody class="table-body">

                                                  <tr *ngFor="let l of CurrentIvfCycleMedicineByCodeController ; let RowIndex = index ">
                                                    <td class="padding-top-4px padding-bottom-4px ">{{RowIndex+1}}</td>
                                                    <!--<td class="padding-top-4px padding-bottom-4px padding-left-0px">
                                <div class="height-16px" >
                                  <label class="font-size-14 margin-bottom-0px">{{l.MedicineName}}</label>
                                </div>
                                <div class="height-16px" >
                                  <label class="font-size-12px margin-bottom-0px">{{l.Dose}}</label>
                                </div>
                                <div class="height-16px" >
                                  <label class="font-size-12px margin-bottom-0px">{{l.DosageForm}}</label>
                                </div>
                                <div class="height-16px" >
                                  <label class="font-size-12px margin-bottom-0px">{{l.Instructions}}</label>
                                </div>
                                <div class="height-16px" >
                                  <label class="font-size-12px margin-bottom-0px">{{l.Remarks}}</label>
                                </div>

                              </td>-->
                                                    <td class="padding-top-4px padding-bottom-4px padding-left-4"><label class="font-size-12px margin-bottom-0px">{{l.MedicineName}}</label></td>
                                                    <td class=" padding-top-4px padding-bottom-4px ">{{l.Dosage}}{{l.DurationType}}</td>
                                                    <td class=" padding-top-4px padding-bottom-4px padding-left-4">{{l.DosageForm}}</td>
                                                    <td class=" padding-top-4px padding-bottom-4px ">{{l.MedicineInstructions}}</td>

                                                    <td class="padding-top-4px padding-bottom-4px ">
                                                      <div class="test-icons float-right" *ngIf="EmbryoTransferData2">
                                                        <a (click)="delMedicine(l)" title="Remove" *ngIf="EmbryoTransferData2.ActivityStatus !=='Completed'"><i class="fa fa-times color-Rejected nav-link-hand"></i></a>
                                                        <a (click)="EditMedicine(l)" class="nav-link-hand education-navlink  color-Assign" title="Edit" *ngIf="EmbryoTransferData2.ActivityStatus !=='Completed'">
                                                          <span class="badge"><i class="fas fa-pencil-alt"></i></span>
                                                        </a>
                                                      </div>
                                                    </td>
                                                    <!--<td class="padding-top-4px padding-bottom-4px">


                              </td>-->




                                                  </tr>

                                                </tbody>
                                              </table>

                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                        <div *ngIf="EmbryoTransFerEndInfo && EmbryoTransferData2">
                          <form class="form " novalidate="" (ngSubmit)="onSubmitNotes()" #f="ngForm">
                            <div class="accordion" id="accordionExampledate" *ngIf="EmbryoTransferData2.ActivityStatus !=='Completed'">
                              <div class="card margin-bottom-5px">
                                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingdate">
                                  <div class="row">
                                    <div class="col-md-4">
                                      <h5 class="mb-0 height-24px">
                                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapsedate" aria-expanded="true" aria-controls="collapsedate">
                                          Notes
                                        </button>
                                      </h5>
                                    </div>
                                    <div class="col-md-8 ">
                                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                      <button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="EmbryoTransferData2.ActivityStatus !=='Completed'">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                                    </div>
                                  </div>


                                </div>

                                <div id="collapsedate" class="collapse show" aria-labelledby="headingdate" data-parent="#accordionExampledate">
                                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                        <div class="row">
                                          <div class="col-md-2 padding-right-0px text-align-right margin-top-4px ">
                                            <label for="diaplayName" class="font-size-12px margin-bottom-0px">Notes </label>
                                          </div>


                                          <div class="col-md-9">

                                            <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Notes"
                                                      name="EmbryoTransFerEndInfo.Notes"
                                                      [(ngModel)]="EmbryoTransFerEndInfo.Notes" minlength="1" maxlength="1000"
                                                      #addconcerns_text="ngModel" required></textarea>
                                            <small class="form-text text-danger"
                                                   *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))">(Required)</small>


                                          </div>

                                        </div>


                                      </div>
                                    </div>

                                  </div>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                        <div *ngIf="EmbryoTransFerEndInfo && EmbryoTransferData2">
                          <form class="form " novalidate="" (ngSubmit)="onSubmit_NextScanDate()" #f="ngForm">
                            <div class="accordion" id="accordionExampledate" *ngIf="EmbryoTransferData2.ActivityStatus =='Completed'">
                              <div class="card margin-bottom-5px">
                                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingdate">
                                  <div class="row">
                                    <div class="col-md-4">
                                      <h5 class="mb-0 height-24px">
                                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapsedate" aria-expanded="true" aria-controls="collapsedate">
                                          Notes
                                        </button>
                                      </h5>
                                    </div>
                                    <div class="col-md-8 ">
                                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                      <!--<button (click)="SaveEndometriumdetails()" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="!SelectedpatientDetails.IsReadyForPickup">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>-->
                                    </div>
                                  </div>


                                </div>

                                <div id="collapsedate" class="collapse show" aria-labelledby="headingdate" data-parent="#accordionExampledate">
                                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                        <div class="row font-size-12px">
                                          <div class="col-md-2  text-align-right margin-top-4px ">
                                            <label for="diaplayName" class=" margin-bottom-0px">Notes </label>
                                          </div>:


                                          <div class="col-md-9 margin-tg-auto">

                                            <!--<div class="date-form">
    <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
           name="dp1" [(ngModel)]="OvulationTriggerDate" ngbDatepicker #d1="ngbDatepicker" #DateOfBirth="ngModel">
    <small class="form-text text-danger"
           *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
    <a (click)="d1.toggle()" class="nav-link-hand">
      <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

    </a>

  </div>-->


                                            <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Notes"
                                                      name="EmbryoTransFerEndInfo.Notes"
                                                      [(ngModel)]="EmbryoTransFerEndInfo.Notes" minlength="1" maxlength="1000"
                                                      #addconcerns_text="ngModel" required></textarea>
                                            <small class="form-text text-danger"
                                                   *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))">(Required)</small>


                                            <label class="margin-bottom-0px ">{{FollicularScanEndInfo.NextDocDate | date:'MMM-dd-yyyy'}}</label>
                                          </div>

                                        </div>


                                      </div>
                                    </div>

                                  </div>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-3 padding-left-0px background-white" *ngIf="ScanDetails">
          <div class="row">
            <div class="position-fixed-Activities">

              <div class="col-md-12">
                <div class="card">
                  <div class="card-header wh-header  padding-left-0px padding-right-0px border-bottom-0px padding-top-0px">
                    <ul class="nav nav-tabs nav-tab-ivf margin-top-3px" id="tabContent">
                      <li class="active nav-link-hand margin-right-5px"><a class="nav-item-ivf active" href="#details" data-toggle="tab">Activities</a></li>
                      <li class="nav-link-hand margin-right-5px"><a class="nav-item-ivf" href="#access-security" data-toggle="tab">Forms</a></li>

                    </ul>
                  </div>
                  <div class="card-body padding-all-0px">
                    <div class="tab-content">
                      <div class="tab-pane active" id="details">
                        <!--<div class="card">
                          <div class="card-body padding-all-0px">
                            <div class="row margin-right-0px margin-left-0px margin-top-5px">
                              <div class="col-md-9 margin-left-15px padding-right-0px padding-left-0px ">
                                <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
                              </div>
                              <div class="col-md-2">
                                <button type="button"  class="btn btn-ivf-new  btn-sm background-primary border-all-secondary" tooltip="Add"><i class="fas fa-plus nav-link-hand"></i></button>
                              </div>
                            </div>

                                                  <div class="row margin-top-10 margin-left-0px">
                                                    <div class="col-md-12">
                                                      <div class="table-component">
                                                        <div class="table-responsive overflow-x">


                                                          <table class="table table-striped margin-left-zero"
                                                                 cols="auto,2*,*,*,*,*,*,*">

                                                            <thead class="">
                                                              <tr>

                                          <th class="td-width-103px font-weight-normal td-padding-tb">
                                            Date
                                          </th>

                                          <th class="font-weight-normal td-padding-tb">
                                            Remarks
                                          </th>


                                          <th class="text-align-center font-weight-normal td-padding-tb">
                                            Status
                                          </th>











                                                              </tr>
                                                            </thead>

                                                            <tbody class="table-body">
                                                              <tr>

                                                                <td class="padding-right-0px td-padding-tb align-top font-size-12px">
                                                                  13-JUN-19


                                                                </td>




                                                                <td class="td-padding-tb">
                                                                  <div>Day 4 Grading</div>
                                                                  <div class="td-padding-tb td-elipsis2">Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod.</div>
                                                                </td>

                                          <td class="td-padding-tb text-align-center align-top">
                                            <i class="fas fa-circle light-gray-badge nav-link-hand  ">
                                            </i>
                                          </td>

                                        </tr>

                                      </tbody>

                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>-->
                        <!--<cycleactivities [ActorCode]="SelectedpatientDetails.EggSourceActorCode" [CycleCode]="SelectedpatientDetails.CycleActivity"></cycleactivities>-->
                        <div *ngIf="SelectedpatientDetails.EggSourceType=='DONOR' || SelectedpatientDetails.EggSourceType=='Donor'">
                          <cycleactivities [ActorCode]="ReceipientActorCode" [CycleCode]="SelectedpatientDetails.TreatmentCycleCode" [LMPDate]="LMPDate" ActivityName="ETREC" [CanLoadReport]='CanLoadReport'></cycleactivities>
                        </div>
                        <div *ngIf="SelectedpatientDetails.EggSourceType=='Self'">
                          <cycleactivities [ActorCode]="ReceipientActorCode" [CycleCode]="SelectedpatientDetails.TreatmentCycleCode" [LMPDate]="LMPDate" ActivityName="ETSelf" [CanLoadReport]='CanLoadReport'></cycleactivities>
                        </div>

                      </div>
                      <div class="tab-pane" id="access-security">
                        <div class="card">
                          <div class="card-body padding-bottom-0px padding-top-0px">
                            <div class="row">
                              <div class="col-md-12">
                                <div class="row">
                                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                    <div class="row">


                                      <div class="col-md-12">
                                        <CustomDataByRequestType RequestedType="FDActorReports" ActorCode={{ActorCodeLoad()}}
                                                                 id="CurrentFdActorReportsDocController.TemplateName" SelectedValue=""
                                                                 [(ngModel)]="SelectedReport"
                                                                 (keyChange)="onAssignedToActorCode($event)"
                                                                 name="CurrentFdActorReportsDocController.TemplateName">
                                        </CustomDataByRequestType>
                                        <!--<CodeTypeValue CodeType="RELTP"></CodeTypeValue>-->


                                      </div>
                                      <div class="chatsd product-chart-wrapper product-chat-width-100 agreement-chart-wrapper ps ps2 padding-lrt " data-ps-id="dfsfsde">
                                        <div *ngIf="fo && fo.AutoSections" class="margin-top-10">


                                          <div class="row card margin-left-0px margin-right-0px margin-bottom-5px" *ngFor="let section of  fo.AutoSections;let RowIndex = index">
                                            <div [id]="'accordion'+RowIndex">
                                              <div [ngSwitch]="section.SectionType">
                                                <div class="card-header wh-header font-size-16px  padding-top-0px padding-bottom-0px border-left-clinical padding-l-8px padding-right-0px font-weight-normal2 font-size-16px" [id]="'heading'+RowIndex">
                                                  <h5 class="mb-0">
                                                    <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" [attr.data-target]="'#collapse_cre'+RowIndex"
                                                            aria-expanded="true" [attr.aria-controls]="'collapse_cre'+RowIndex">
                                                      {{section.Data.Title}}

                                                    </button>
                                                  </h5>

                                                </div>
                                                <div [id]="'collapse_cre'+RowIndex" class="collapse show collapse-show3" [attr.aria-labelledby]="'heading'+RowIndex"
                                                     [attr.data-parent]="'#accordion'+RowIndex">
                                                  <div class="card-body padding-bottom-19px padding-right-0px padding-top-0px">

                                                    <div class="row" *ngSwitchCase="'AttrVal'">
                                                      <div class="col-md-12 padding-l-0px padding-right-0px" *ngFor="let field of  section.Fields">


                                                        <div [ngSwitch]="field.Data.ValueType">
                                                          <div class="row" *ngSwitchCase="'Bool'">
                                                            <auto-gen-bool class="col-md-12" [Data]="field" [field]="field.Data"
                                                                           mode="view2">
                                                            </auto-gen-bool>
                                                          </div>
                                                          <div class="row" *ngSwitchCase="'List'">
                                                            <auto-gen-list class="col-md-12 padding-l-0px padding-right-0px" [Data]="field" [field]="field.Data"
                                                                           mode="view2">
                                                            </auto-gen-list>
                                                          </div>
                                                          <div class="row margin-top-5px" *ngSwitchCase="'Text'">
                                                            <auto-gen-text class="col-md-12" [field]="field.Data" mode="view2"></auto-gen-text>
                                                          </div>
                                                          <div class="row margin-top-5px" *ngSwitchCase="'CVS'">
                                                            <auto-gen-cvs class="col-md-12" [field]="field.Data" mode="view2"></auto-gen-cvs>
                                                          </div>
                                                          <div class="row" *ngSwitchCase="'Date'">
                                                            <auto-gen-date class="col-md-12" [field]="field.Data" mode="view2"></auto-gen-date>
                                                          </div>
                                                          <div class="row padding-bottom-10px" *ngSwitchCase="'Grid'">
                                                            <!--<label>Grid: {{field.Title}}</label>-->
                                                            <auto-gen-grid class="col-md-12" [field]="field" mode="view2"></auto-gen-grid>
                                                          </div>

                                                          <div class="row" *ngSwitchDefault>




                                                          </div>





                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div class="row" *ngSwitchCase="'Text'">
                                                      <div class="col-md-12 padding-l-0px padding-right-0px">
                                                        <!--*ngFor="let field of  section.Fields"-->

                                                        <div class="row">
                                                          <div class="col-md-12 " *ngFor="let field of section.Data.Fields">
                                                            <div class="row" *ngIf="field.ValueType=='Text'">

                                                              <div class="col-md-11 padding-left-0px padding-right-0px">

                                                                <textarea class="form-control3 size-2 width-inherit margin-top-5px margin-left-5px" placeholder="Remarks"
                                                                          [ngModelOptions]="{standalone: true}"
                                                                          [(ngModel)]="field.Value" maxlength="600"></textarea>

                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div class="row" *ngSwitchCase="'Image'">
                                                      <div class="col-md-12 padding-l-0px padding-right-0px">
                                                        <!--*ngFor="let field of  section.Fields-->

                                                        <div class="row">
                                                          <div class="col-md-12">
                                                            <div class="table-component">
                                                              <div class="table-responsive">


                                                                <table class="table table-striped margin-left-zero">

                                                                  <!--<thead class="">
                                                                    <tr>
                                                                      <th class="min-width-0px width-57px padding-top-4px padding-bottom-4px"></th>

                                                                      <th class="width-53px padding-top-4px padding-bottom-4px">#</th>
                                                                      <th class="width-178px padding-top-4px padding-bottom-4px">Title</th>
                                                                      <th class="padding-top-4px padding-bottom-4px">Image</th>

                                                                      <th class="padding-top-4px padding-bottom-4px">Comments</th>
                                                                      <th class="padding-top-4px padding-bottom-4px"></th>
                                                                    </tr>
                                                                  </thead>-->
                                                                  <tbody class="table-body">

                                                                    <tr *ngFor="let field of section.Data.Fields; let RowIndex = index ">
                                                                      <!--<td class="padding-top-0px padding-bottom-0px ">

                                                                        <input type="checkbox" [(ngModel)]="field.IsSelected" />
                                                                        <i class="input-helper"></i>

                                                                      </td>-->
                                                                      <td class="padding-top-0px padding-bottom-0px ">{{RowIndex+1}}</td>

                                                                      <td class="padding-top-0px padding-bottom-0px ">
                                                                        <!--<input class="form-control " [(ngModel)]="field.Title" type="text" [ngModelOptions]="{standalone: true}" />-->
                                                                        <div><label class="margin-bottom-0px">{{field.Title}}</label></div>
                                                                        <div><label class="margin-bottom-0px"> {{field.Remarks}}</label></div>
                                                                      </td>
                                                                      <td class="padding-top-0px padding-bottom-0px padding-left-5px">

                                                                        <!--<div *ngIf="!field.HasImage">
                                                                          <button class="button-service-save font-size-16px color-secondary nav-link-hand" title="Save">
                                                                            <i class="fas fa-ellipsis-h"></i>
                                                                          </button>
                                                                        </div>-->
                                                                        <div *ngIf="field.HasImage">
                                                                          <img class="img-circle-56 font-size-12px" [src]="field.ImageFile" onError="this.src='dummy.jpg';">
                                                                          <!--<button type="button" class="btn  btn-sm button-new-health margin-top-left" tooltip="Add" (click)="openDocContent(field)" *ngIf="field?.IsSelected"><i class="fas fa-plus nav-link-hand"></i></button>-->

                                                                        </div>
                                                                      </td>
                                                                      <!--<td class="padding-top-0px padding-bottom-0px">

                                                                        {{field.Remarks}}

                                                                      </td>-->
                                                                      <!--<td class="text-align-right padding-top-0px padding-bottom-0px">

                                                                        <a class="nav-link-hand font-size-20px margin-left-10px" title="Remove" *ngIf="field?.IsSelected"><i class="fa fa-times color-Rejected nav-link-hand"></i></a>

                                                                      </td>-->



                                                                    </tr>

                                                                  </tbody>

                                                                </table>

                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <!--<label>{{f.Title}}</label>
                                                    <label class="margin-left-auto"></label>-->

                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <!--<div *ngFor="let l of CurrentFdActorReportsDocController">
                                              <label>{{l.TemplateName}}</label>
                                            </div>-->


                                          </div>

                                        </div>
                                      </div>
                                    </div>

                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>





      </div>
    </div>

  </div>
  <div class="job-posts placements agreements margin-top-service-30px top-link2 overscrollbehaviour">


    <div class="row" *ngIf="displayPatientdata">
      <div class="col-md-3 col-12 padding-right-0px">

        <div class="position-fixed-sm-scans border-right2 padding-right-5px">
          <div class="card">

            <div class="card-header wh-header header3 padding-right-0px bk-color-light padding-bottom-0px border-bottom-0">
              <div class="row margin-top10px margin-left-20px  nav-link-hand">
                <div class="col-md-10 col-10 padding-left-0px">
                  <label class="wh-header font-weight-normal card-title-schedule-bl border-radius-4px padding-top-0px padding-left-7px padding-bottom-0px margin-bottom-0px bk-color-light">
                    Embryo Transfer
                  </label>
                </div>
                <div class="col-md-1 col-1">
                  <a class="nav-link-hand margin-top-auto margin-bottom margin-left-auto" title="Back To Ivf Bench" (click)="BackTodashboard2()"><i class="fas fa-angle-double-left font-size-19px margin-top-5px"></i></a>
                </div>




              </div>




            </div>
            <div class="card-body padding-top-0px padding-left-0px padding-right-0px bk-color-light padding-right-0px padding-bottom-0px">
              <div class="row border-top margin-left-0px margin-right-0px margin-bottom-5px">
                <div class="col-md-1 col-1 padding-right-0px" (click)="DecrementDate()">
                  <a title="Previous" class="nav-link-hand">
                    <i class="fas fa-caret-left margin-top-5px font-size-28px color-secondary-hover"></i>
                  </a>
                </div>
                <div class="col-md-5 col-5 col-sm-4 padding-right-12px my-profile-form  padding-left-5px">
                  <div class="date-form margin-top-5px form-group margin-bottom-0px">
                    <input class="form-control" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
                           name="SelectedFromDate" [(ngModel)]="SelectedFromDate" (ngModelChange)="dataChanged($event)" ngbDatepicker #d="ngbDatepicker">

                    <a (click)="d.toggle()" class="nav-link-hand">
                      <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                    </a>

                  </div>



                </div>

                <div class="col-md-1 col-1 padding-left-0px padding-right-0px" (click)="IncrementDate()">
                  <a title="Next" class="nav-link-hand">
                    <i class="fas fa-caret-right margin-top-5px font-size-28px color-secondary-hover"></i>
                  </a>
                </div>
              </div>
              <div class="row margin-right-0px margin-left-0px">
                <div class="col-md-11 col-11 margin-bottom-10px margin-top-10 margin-left-10px padding-right-0px padding-left-10px">
                  <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
                  <!--<input type="search"  [title]="searchTitle"  (change)="criteriaChange($event)" class="form-control padding-bottom-2px width-230px margin-top-10 margin-bottom-10px" placeholder="Search....">-->
                </div>
                <div class="col-md-2" hidden>
                  <button type="button" class="btn btn-primary btn-sm" tooltip="Add" hidden><i class="fas fa-plus nav-link-hand"></i></button>
                </div>
                <div class="col-md-1 padding-left-8px" hidden>
                  <a class="nav-link-hand education-navlink" tooltip="Edit">
                    <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
                  </a>

                </div>
                <div class="col-md-1 padding-left-8px" hidden>
                  <a class="nav-link-hand education-navlink" tooltip="Delete">
                    <span class="badge font-size-14">
                      <i class="far fa-trash-alt"></i>
                    </span>
                  </a>
                </div>

              </div>
              <div>
                <div class="chatsd product-chart-wrapper product-chat-width-100 agreement-chart-wrapper ps ps2 padding-lrt " data-ps-id="dfsfsde">

                  <div class="row border-bottom row-for-scans margin-left16px nav-link-hand" (click)="Selectedpatient2(l)" *ngFor="let l of CurrentReadyForTransferBetweenDateController">
                    <div class="col-md-2 col-2 padding-left-0px " (click)="Selectedpatient2(l)">


                      <!--<img class="user-image-circle-65px img2 margin-left-6px" src="dummy.jpg">-->

                      <img class="user-image-circle-65px img2 margin-left-6px" [src]="l.OwnerPatientImageFile" onError="this.src='dummy.jpg';">

                    </div>
                    <div class="col-md-7 col-5 margin-top-5px padding-right-0px padding-left-0px">
                      <div class="row row-height-17px">
                        <div class="col-md-12 col-12">
                          <label class="margin-bottom-0px">{{l.OwnerName}}</label>
                        </div>

                      </div>
                      <div class="row row-height-17px">
                        <div class="col-md-12 col-12">
                          <label class="font-size-12px margin-bottom-0px light-gray-new">{{l.OwnerAgeYears}},{{l.OwnerFormattedCode}}</label>
                        </div>
                      </div>
                      <div class="row row-height-17px">
                        <div class="col-md-4 col-4">
                          <label class="font-size-12px margin-bottom-0px light-gray-new">{{l.OwnerTelephone1}}</label>
                        </div>
                      </div>

                    </div>
                    <div class="col-md-3 offset-2 col-3 padding-left-0px margin-top-5px">
                      <div class="text-align-center">
                        <i class="fas fa-check-circle color-icon-completed "></i>
                      </div>
                      <div class="text-align-center"><label class="font-size-12px">10:30</label></div>
                    </div>
                  </div>

                </div>
              </div>

            </div>

          </div>
        </div>

      </div>
    </div>
    <div class="row margin-top-sm-13" *ngIf="displayscansdata">
      <div class="col-12">
        <div class="card">
          <div class="card-header wh-header header3 padding-right-0px bk-color-light padding-bottom-0px border-bottom-1px">
            <div class="row margin-top10px margin-left-20px  nav-link-hand">
              <div class="col-md-10 col-10 padding-left-0px">
                <div class="row">
                  <div class="col-md-7 col-7">
                    <label class="wh-header font-weight-normal card-title-schedule-bl border-radius-4px padding-top-0px padding-left-7px padding-bottom-0px margin-bottom-0px bk-color-light">
                      Embryo Transfer
                    </label>
                  </div>
                  <!--<div class="col-md-6 col-5 margin-top-3px padding-left-0px padding-right-0px text-align-right" *ngIf="FollicularPickupEndInfo">
                    <a class="nav-link-hand patientreg-link  margin-bottom-8px font-weight-normal" (click)="pickup()" title="Is Pickup Confirmed" *ngIf="!FollicularPickupEndInfo.IsPickedUp">Is Pickup Confirmed</a>

                  </div>-->
                </div>


              </div>
              <div class="col-md-1 col-1">
                <a class="nav-link-hand margin-top-auto margin-bottom margin-left-auto" title="Back To Ivf Bench" (click)="BackToPatientdata()"><i class="fas fa-angle-double-left font-size-19px margin-top-5px"></i></a>
              </div>




            </div>




          </div>
          <div class="card-body padding-all-0px">
            <div class="row margin-top-10" *ngIf="SelectedpatientDetails">
              <div class="col-md-1 col-2 ">
                <img class=" margin-left-6px image-width-scans width-small-52px" [src]="SelectedpatientDetails.OwnerPatientImageFile" onError="this.src='dummy.jpg';">
                <!--<img class=" margin-left-6px image-width-scans width-small-52px" src="dummy.jpg">-->
              </div>
              <div class="col-md-4 col-5 ">
                <div class="row row-height-17px margin-left-0px">

                  <label class="margin-bottom-0px font-weight-normal color-secondary">{{SelectedpatientDetails.OwnerName}} </label>
                </div>

                <div class="row row-height-17px">
                  <div class="col-md-12">
                    <label class="font-size-12px margin-bottom-0px font-weight-normal">{{SelectedpatientDetails.OwnerAgeYears}},{{SelectedpatientDetails.OwnerFormattedCode}}</label>
                  </div>
                </div>
                <div class="row row-height-17px">
                  <div class="col-md-4">

                    <label class="font-size-12px margin-bottom-0px font-weight-normal">{{SelectedpatientDetails.OwnerTelephone1}}</label>
                  </div>
                </div>
              </div>
              <div class="offset-md-2  col-5 padding-left-0px col-md-4 text-align-right padding-right-0px">
                <div class="row font-size-12px">
                  <div class="col-md-6 col-6 padding-right-9px text-align-right-small">
                    <label class="font-weight-normal font-size-12px margin-bottom-0px">Check In </label>
                  </div>:
                  <div class="col-md-5 col-5 padding-right-0px padding-left-5px text-align-right">
                    <label class="font-weight-normal font-size-12px margin-bottom-0px">10:30 AM</label>
                  </div>
                </div>
                <div class="row font-size-12px">
                  <div class="col-md-6 col-6 padding-right-9px text-align-right-small">
                    <label class="font-weight-normal font-size-12px margin-bottom-0px">Status </label>
                  </div>:
                  <div class="col-md-5 col-5 padding-right-0px padding-left-5px text-align-right">
                    <label class="font-weight-normal font-size-12px margin-bottom-0px">Completed</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="row margin-top-10">
              <div class="col-12">
                <div class="chatsd product-chart-wrapper product-chat-width-100 agreement-chart-wrapper ps ps2 padding-lrt " data-ps-id="dfsfsde">

                  <div *ngIf="EmbryoTransFerEndInfo">
                    <form class="form " novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
                      <div class="accordion" id="accordionExample2">

                        <div class="card margin-bottom-5px">
                          <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingTwo">
                            <div class="row">
                              <div class="col-md-4 col-4">
                                <h5 class="mb-0 height-24px">
                                  <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                                    Schedule
                                  </button>
                                </h5>
                              </div>
                              <div class="col-md-8 col-8">
                                <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                <button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                              </div>
                              <!--<div class="col-md-6">
                                <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                                <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                              </div>-->
                            </div>


                          </div>

                          <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo" data-parent="#accordionExample2">
                            <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-15px padding-right-5px">
                              <!--<div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-0px">
                                  <div class="row">



                                    <div class="col-md-3 col-4 margin-top-3px">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Planned Time</label>


                                    </div>:
                                    <div class="col-7 margin-top-3px">
                                      <label class="font-weight-normal font-size-12px margin-bottom-0px">{{EmbryoTransFerEndInfo.TransferDate}}</label>

                                    </div>

                                  </div>


                                </div>
                              </div>-->
                              <div class="row my-profile-form margin-top-3px">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-3 col-4 padding-right-0px  margin-tg-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Actual Date </label>
                                    </div>




                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form margin-bottom-7px">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">



                                    <div class="col-md-3 col-11">

                                      <div class="date-form">
                                        <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                               name="dp1" [(ngModel)]="TransferEndDate" ngbDatepicker #d1="ngbDatepicker" #DateOfBirth="ngModel">
                                        <small class="form-text text-danger"
                                               *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
                                        <a (click)="d1.toggle()" class="nav-link-hand">
                                          <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                        </a>

                                      </div>

                                    </div>

                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 col-6 padding-right-0px text-align-right margin-tg-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Actual Time </label>
                                    </div>


                                    <div class="col-md-3 col-3">


                                      <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                      [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                      name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                                      maxlength="100" required>-->
                                      <!--<small class="form-text text-danger"
                                             *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                    </div>

                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form margin-bottom-3px">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-7px">
                                  <div class="row">

                                    <div class="col-md-3 col-11">

                                      <input type="time" class="form-control" id="EmbryoTransFerEndInfo.TransferEndTime" placeholder="Trigger Time"
                                             [(ngModel)]="EmbryoTransFerEndInfo.TransferEndTime"
                                             name="EmbryoTransFerEndInfo.TransferEndTime" pattern="^[\sa-zA-Z0-9,._\-?]*$" #ActivityTime="ngModel" />
                                      <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                      [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                      name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                                      maxlength="100" required>-->
                                      <!--<small class="form-text text-danger"
                                             *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                    </div>




                                  </div>


                                </div>
                              </div>

                            </div>
                          </div>
                        </div>

                      </div>
                    </form>
                  </div>
                  <div *ngIf="EmbryoTransFerEndInfo">
                    <form class="form " novalidate="" (ngSubmit)="onSubmitTeam()" #f="ngForm">
                      <div class="accordion" id="accordionExampletest">
                        <div class="card margin-bottom-5px">
                          <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingtest">
                            <div class="row">
                              <div class="col-md-4 col-4">
                                <h5 class="mb-0 height-24px">
                                  <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapsetest" aria-expanded="true" aria-controls="collapsetest">
                                    Team
                                  </button>
                                </h5>
                              </div>
                              <div class="col-md-8 col-7 padding-right-0px">
                                <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                <button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                              </div>
                            </div>


                          </div>

                          <div id="collapsetest" class="collapse show" aria-labelledby="headingtest" data-parent="#accordionExampletest">
                            <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-15px padding-right-5px">
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-3 col-4 padding-right-0px text-align-right">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Surgeon</label>
                                    </div>


                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form margin-bottom-3px">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-7px">
                                  <div class="row">


                                    <div class="col-md-4 col-11 padding-right-0px">
                                      <CustomDataByRequestType RequestedType="SURGEON_LIST"
                                                               id="EmbryoTransFerEndInfo.Surgeon" SelectedValue="EmbryoTransFerEndInfo.Surgeon"
                                                               [(ngModel)]="EmbryoTransFerEndInfo.Surgeon" (keyChange)="onAssignedToActorCodesurgeon($event)"
                                                               name="EmbryoTransFerEndInfo.Surgeon" required>
                                      </CustomDataByRequestType>
                                      <!--name="CurrentEditCounsellingPalnRequest.Concerns"
                                      [(ngModel)]="CurrentEditCounsellingPalnRequest.Concerns" required minlength="1" maxlength="100"
                                      #addconcerns_text="ngModel"-->
                                      <!--<small class="form-text text-danger"
                                      *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))">(Required)</small>-->

                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-3 col-4 padding-right-0px text-align-right">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Asst.Surgeon</label>
                                    </div>


                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form margin-bottom-3px">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-7px">
                                  <div class="row">


                                    <div class="col-md-4 col-11 padding-right-0px">
                                      <CustomDataByRequestType RequestedType="ASSISTANT_SURGEON_LIST"
                                                               id="EmbryoTransFerEndInfo.AsstSurgeon" SelectedValue="EmbryoTransFerEndInfo.AsstSurgeon"
                                                               [(ngModel)]="EmbryoTransFerEndInfo.AsstSurgeon" (keyChange)="onAssignedToActorCodeAsstSurgeon($event)"
                                                               name="EmbryoTransFerEndInfo.AsstSurgeon" required>
                                      </CustomDataByRequestType>
                                      <!--name="CurrentEditCounsellingPalnRequest.Concerns"
                                      [(ngModel)]="CurrentEditCounsellingPalnRequest.Concerns" required minlength="1" maxlength="100"
                                      #addconcerns_text="ngModel"-->
                                      <!--<small class="form-text text-danger"
                                      *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))">(Required)</small>-->

                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-3 col-4 padding-right-0px text-align-right">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Embryologist</label>
                                    </div>


                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form margin-bottom-3px">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-7px">
                                  <div class="row">


                                    <div class="col-md-4 col-11 padding-right-0px">
                                      <CustomDataByRequestType RequestedType="ASSISTANT_SURGEON_LIST"
                                                               id="EmbryoTransFerEndInfo.Embryologist" SelectedValue=""
                                                               [(ngModel)]="EmbryoTransFerEndInfo.Embryologist" (keyChange)="onAssignedToActorCodeAsstSurgeon2($event)"
                                                               name="EmbryoTransFerEndInfo.Embryologist" required>
                                      </CustomDataByRequestType>
                                      <!--name="CurrentEditCounsellingPalnRequest.Concerns"
                                      [(ngModel)]="CurrentEditCounsellingPalnRequest.Concerns" required minlength="1" maxlength="100"
                                      #addconcerns_text="ngModel"-->
                                      <!--<small class="form-text text-danger"
                                      *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))">(Required)</small>-->

                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-3 col-4 padding-right-0px text-align-right">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Anaesthesiologist</label>
                                    </div>


                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form margin-bottom-3px">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-7px">
                                  <div class="row">


                                    <div class="col-md-4 col-11 padding-right-0px">
                                      <CustomDataByRequestType RequestedType="ANAESTHETIST_LIST"
                                                               id="EmbryoTransFerEndInfo.Anesthesiologist" SelectedValue="EmbryoTransFerEndInfo.Anesthesiologist"
                                                               [(ngModel)]="EmbryoTransFerEndInfo.Anesthesiologist" (keyChange)="onAssignedToActorCodeAnaesthetist($event)"
                                                               name="EmbryoTransFerEndInfo.Anesthesiologist" required>
                                      </CustomDataByRequestType>
                                      <!--name="CurrentEditCounsellingPalnRequest.Concerns"
                                      [(ngModel)]="CurrentEditCounsellingPalnRequest.Concerns" required minlength="1" maxlength="100"
                                      #addconcerns_text="ngModel"-->
                                      <!--<small class="form-text text-danger"
                                      *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))">(Required)</small>-->

                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-3 col-4 padding-right-0px text-align-right">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Anaesthesia</label>
                                    </div>


                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form margin-bottom-3px">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-7px">
                                  <div class="row">


                                    <div class="col-md-4 col-11 padding-right-0px">
                                      <CodeTypeValue CodeType="IVFAT"
                                                     id="EmbryoTransFerEndInfo.AnaesthesiaType"
                                                     [(ngModel)]="EmbryoTransFerEndInfo.AnaesthesiaType" SelectedValue="EmbryoTransFerEndInfo.AnaesthesiaType"
                                                     name="EmbryoTransFerEndInfo.AnaesthesiaType">
                                      </CodeTypeValue>
                                      <!--name="CurrentEditCounsellingPalnRequest.Concerns"
                                      [(ngModel)]="CurrentEditCounsellingPalnRequest.Concerns" required minlength="1" maxlength="100"
                                      #addconcerns_text="ngModel"-->
                                      <!--<small class="form-text text-danger"
                                      *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))">(Required)</small>-->

                                    </div>
                                  </div>


                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                  <div *ngIf="EmbryoTransFerEndInfo">
                    <form class="form " novalidate="" (ngSubmit)="onSubmitTransferDetails()" #f="ngForm">
                      <div class="accordion" id="accordionExamplemedicine">
                        <div class="card margin-bottom-5px">
                          <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingmedicine">
                            <div class="row">
                              <div class="col-md-4 col-4">
                                <h5 class="mb-0 height-24px">
                                  <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapsemedicine" aria-expanded="true" aria-controls="collapsemedicine">
                                    Transfer Details
                                  </button>
                                </h5>
                              </div>
                              <div class="col-md-8 col-7 padding-right-0px">
                                <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                <button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                              </div>
                            </div>


                          </div>

                          <div id="collapsemedicine" class="collapse show" aria-labelledby="headingmedicine" data-parent="#accordionExamplemedicine">
                            <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-15px padding-right-5px">
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-3 col-8 padding-right-0px text-align-right">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Culture Media Used</label>
                                    </div>


                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form margin-bottom-3px">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-7px">
                                  <div class="row">


                                    <div class="col-md-4 col-11 padding-right-0px">
                                      <CodeTypeValue CodeType="CULME"
                                                     id="EmbryoTransFerEndInfo.CultureMedia"
                                                     [(ngModel)]="EmbryoTransFerEndInfo.CultureMedia" SelectedValue="EmbryoTransFerEndInfo.CultureMedia"
                                                     name="EmbryoTransFerEndInfo.CultureMedia">
                                      </CodeTypeValue>


                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-3 col-4 padding-right-0px text-align-right">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Method</label>
                                    </div>


                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form margin-bottom-3px">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-7px">
                                  <div class="row">


                                    <div class="col-md-4 col-11 padding-right-0px">
                                      <CodeTypeValue CodeType="TRNSM"
                                                     id="EmbryoTransFerEndInfo.TransferMethod"
                                                     [(ngModel)]="EmbryoTransFerEndInfo.TransferMethod" SelectedValue="EmbryoTransFerEndInfo.TransferMethod"
                                                     name="EmbryoTransFerEndInfo.TransferMethod">
                                      </CodeTypeValue>


                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-3 col-4 padding-right-0px text-align-right">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Catheter Type</label>
                                    </div>


                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form margin-bottom-3px">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-7px">
                                  <div class="row">


                                    <div class="col-md-4 col-11 padding-right-0px">
                                      <CodeTypeValue CodeType="CATUS"
                                                     id="EmbryoTransFerEndInfo.CatheterType"
                                                     [(ngModel)]="EmbryoTransFerEndInfo.CatheterType" SelectedValue="EmbryoTransFerEndInfo.CatheterType"
                                                     name="EmbryoTransFerEndInfo.CatheterType">
                                      </CodeTypeValue>


                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-3 col-4 padding-right-0px text-align-right">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Catheter Used</label>
                                    </div>


                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form margin-bottom-3px">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-7px">
                                  <div class="row">


                                    <div class="col-md-4 col-11 padding-right-0px">
                                      <CodeTypeValue CodeType="CATTY"
                                                     id="EmbryoTransFerEndInfo.Catheter"
                                                     [(ngModel)]="EmbryoTransFerEndInfo.Catheter" SelectedValue="EmbryoTransFerEndInfo.Catheter"
                                                     name="EmbryoTransFerEndInfo.Catheter">
                                      </CodeTypeValue>
                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-3 col-4 padding-right-0px text-align-right">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Speculum Used</label>
                                    </div>


                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form margin-bottom-3px">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-7px">
                                  <div class="row">


                                    <div class="col-md-4 col-11 padding-right-0px">
                                      <CodeTypeValue CodeType="SPECU"
                                                     id="EmbryoTransFerEndInfo.Speculum"
                                                     [(ngModel)]="EmbryoTransFerEndInfo.Speculum" SelectedValue="EmbryoTransFerEndInfo.Speculum"
                                                     name="EmbryoTransFerEndInfo.Speculum">
                                      </CodeTypeValue>
                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-3 col-8 padding-right-0px text-align-right">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Media Cleaning of Cervical Canal</label>
                                    </div>


                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form margin-bottom-3px">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-7px">
                                  <div class="row">


                                    <div class="col-md-4 col-11 padding-right-0px">
                                      <CodeTypeValue CodeType="CERCL"
                                                     id="EmbryoTransFerEndInfo.CervicalCleaning"
                                                     [(ngModel)]="EmbryoTransFerEndInfo.CervicalCleaning" SelectedValue="EmbryoTransFerEndInfo.CervicalCleaning"
                                                     name="EmbryoTransFerEndInfo.CervicalCleaning">
                                      </CodeTypeValue>
                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-3 col-6 padding-right-0px text-align-right">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Technique</label>
                                    </div>


                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form margin-bottom-3px">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-7px">
                                  <div class="row">


                                    <div class="col-md-4 col-11 padding-right-0px">
                                      <CodeTypeValue CodeType="IVFAT"
                                                     id="EmbryoTransFerEndInfo.Technique"
                                                     [(ngModel)]="EmbryoTransFerEndInfo.Technique" SelectedValue="EmbryoTransFerEndInfo.Technique"
                                                     name="EmbryoTransFerEndInfo.Technique">
                                      </CodeTypeValue>
                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-3 col-6 padding-right-0px text-align-right">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Embryo Transfer</label>
                                    </div>


                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form margin-bottom-3px">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-7px">
                                  <div class="row">


                                    <div class="col-md-4 col-11 padding-right-0px">
                                      <CodeTypeValue CodeType="IVFTP"
                                                     id="EmbryoTransFerEndInfo.TransferType"
                                                     [(ngModel)]="EmbryoTransFerEndInfo.TransferType" SelectedValue="EmbryoTransFerEndInfo.TransferType"
                                                     name="EmbryoTransFerEndInfo.TransferType">
                                      </CodeTypeValue>
                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form margin-bottom-3px">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-0px">
                                  <div class="row">


                                    <div class="col-md-3 col-4 padding-right-0px text-align-right  ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px margin-top-5px">Retained Embryos </label>
                                    </div>


                                    <div class="col-md-3 col-2">
                                      <input type="checkbox" class="width-15px " [(ngModel)]="EmbryoTransFerEndInfo.HasRetainedEmbryos" name="EmbryoTransFerEndInfo.HasRetainedEmbryos">
                                      <!--<CodeTypeValue CodeType="FNSTS"
                                                     id="EmbryoTransFerEndInfo.HasRetainedEmbryos"
                                                     [(ngModel)]="EmbryoTransFerEndInfo.HasRetainedEmbryos" SelectedValue="EmbryoTransFerEndInfo.HasRetainedEmbryos"
                                                     name="EmbryoTransFerEndInfo.HasRetainedEmbryos">
                                      </CodeTypeValue>-->
                                      <!--<input type="text" class="form-control" placeholder="Endometrium Thickness">-->
                                      <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                      [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                      name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                                      maxlength="100" required>-->
                                      <!--<small class="form-text text-danger"
                                             *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form margin-bottom-3px">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-0px">
                                  <div class="row">


                                    <div class="col-md-3 col-4 padding-right-0px text-align-right ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px margin-top-5px">Fragmentation </label>
                                    </div>
                                    <div class="col-md-3 col-1">
                                      <input type="checkbox" class="width-15px " [(ngModel)]="EmbryoTransFerEndInfo.HasFragmentation" name="EmbryoTransFerEndInfo.HasFragmentation">
                                      <!--<CodeTypeValue CodeType="FNSTS"
                                                     id="EmbryoTransFerEndInfo.HasRetainedEmbryos"
                                                     [(ngModel)]="EmbryoTransFerEndInfo.HasRetainedEmbryos" SelectedValue="EmbryoTransFerEndInfo.HasRetainedEmbryos"
                                                     name="EmbryoTransFerEndInfo.HasRetainedEmbryos">
                                      </CodeTypeValue>-->
                                      <!--<input type="text" class="form-control" placeholder="Endometrium Thickness">-->
                                      <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                      [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                      name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                                      maxlength="100" required>-->
                                      <!--<small class="form-text text-danger"
                                             *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                    </div>

                                    <div class="col-md-3 col-3 padding-left-8px" *ngIf="EmbryoTransFerEndInfo.HasFragmentation">
                                      <input type="number" class="form-control" placeholder="%"
                                             id="EmbryoTransFerEndInfo.Fragmentation"
                                             [(ngModel)]="EmbryoTransFerEndInfo.Fragmentation"
                                             name="EmbryoTransFerEndInfo.Fragmentation" #Doctor="ngModel"
                                             maxlength="100" required>
                                      <!--<CodeTypeValue CodeType="FNSTS"
                                                     id="EmbryoTransFerEndInfo.HasRetainedEmbryos"
                                                     [(ngModel)]="EmbryoTransFerEndInfo.HasRetainedEmbryos" SelectedValue="EmbryoTransFerEndInfo.HasRetainedEmbryos"
                                                     name="EmbryoTransFerEndInfo.HasRetainedEmbryos">
                                      </CodeTypeValue>-->
                                      <!--<input type="text" class="form-control" placeholder="Endometrium Thickness">-->
                                      <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                      [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                      name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                                      maxlength="100" required>-->
                                      <!--<small class="form-text text-danger"
                                             *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form margin-bottom-3px">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-0px">
                                  <div class="row">


                                    <div class="col-md-3 col-4 padding-right-0px text-align-right ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px margin-top-5px">Blood on Catheter </label>
                                    </div>


                                    <div class="col-md-3 col-2">
                                      <input type="checkbox" class="width-15px" [(ngModel)]="EmbryoTransFerEndInfo.BloodOnCatheter" name="EmbryoTransFerEndInfo.BloodOnCatheter">
                                      <!--<CodeTypeValue CodeType="FNSTS"
                                                     id="EmbryoTransFerEndInfo.HasRetainedEmbryos"
                                                     [(ngModel)]="EmbryoTransFerEndInfo.HasRetainedEmbryos" SelectedValue="EmbryoTransFerEndInfo.HasRetainedEmbryos"
                                                     name="EmbryoTransFerEndInfo.HasRetainedEmbryos">
                                      </CodeTypeValue>-->
                                      <!--<input type="text" class="form-control" placeholder="Endometrium Thickness">-->
                                      <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                      [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                      name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                                      maxlength="100" required>-->
                                      <!--<small class="form-text text-danger"
                                             *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form margin-bottom-3px">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-0px">
                                  <div class="row">


                                    <div class="col-md-3 col-4 padding-right-0px text-align-right ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px margin-top-5px">Cervical Mucus </label>
                                    </div>


                                    <div class="col-md-3 col-2">
                                      <input type="checkbox" class="width-15px " [(ngModel)]="EmbryoTransFerEndInfo.CervicalMucus" name="EmbryoTransFerEndInfo.CervicalMucus">
                                      <!--<CodeTypeValue CodeType="FNSTS"
                                                     id="EmbryoTransFerEndInfo.HasRetainedEmbryos"
                                                     [(ngModel)]="EmbryoTransFerEndInfo.HasRetainedEmbryos" SelectedValue="EmbryoTransFerEndInfo.HasRetainedEmbryos"
                                                     name="EmbryoTransFerEndInfo.HasRetainedEmbryos">
                                      </CodeTypeValue>-->
                                      <!--<input type="text" class="form-control" placeholder="Endometrium Thickness">-->
                                      <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                      [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                      name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                                      maxlength="100" required>-->
                                      <!--<small class="form-text text-danger"
                                             *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form margin-bottom-3px">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-0px">
                                  <div class="row">


                                    <div class="col-md-3 col-4 padding-right-0px text-align-right ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px margin-top-5px">Retransfer </label>
                                    </div>


                                    <div class="col-md-3 col-2">
                                      <input type="checkbox" class="width-15px" [(ngModel)]="EmbryoTransFerEndInfo.HasRetransfer" name="EmbryoTransFerEndInfo.HasRetransfer">
                                      <!--<CodeTypeValue CodeType="FNSTS"
                                                     id="EmbryoTransFerEndInfo.HasRetainedEmbryos"
                                                     [(ngModel)]="EmbryoTransFerEndInfo.HasRetainedEmbryos" SelectedValue="EmbryoTransFerEndInfo.HasRetainedEmbryos"
                                                     name="EmbryoTransFerEndInfo.HasRetainedEmbryos">
                                      </CodeTypeValue>-->
                                      <!--<input type="text" class="form-control" placeholder="Endometrium Thickness">-->
                                      <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                      [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                      name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                                      maxlength="100" required>-->
                                      <!--<small class="form-text text-danger"
                                             *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                    </div>
                                  </div>


                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>

                  <div class="accordion" id="accordionExamplesizes">
                    <div class="card margin-bottom-5px">
                      <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingsizes">
                        <div class="row">
                          <div class="col-md-4 col-4">
                            <h5 class="mb-0 height-24px">
                              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapsesizes" aria-expanded="true" aria-controls="collapsesizes">
                                Embryo Grading
                              </button>
                            </h5>
                          </div>
                          <div class="col-md-8 col-7 padding-right-0px" hidden>
                            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                            <button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                          </div>
                        </div>


                      </div>

                      <div id="collapsesizes" class="collapse show" aria-labelledby="headingsizes" data-parent="#accordionExamplesizes">
                        <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-15px padding-right-5px">
                          <div class="table-component">
                            <div class="table-responsive">


                              <table class="table table-striped margin-left-zero width-50-new">
                                <thead class="">
                                  <tr>

                                    <th class="min-width-0px padding-left-0px padding-right-0px">
                                      S.No
                                    </th>



                                    <!--<th class="td-well-width-79px">
                                      Well #
                                    </th>

                                    <th class="th-width-95px">Denuded</th>
                                    <th>
                                      Ins.Tech
                                    </th>-->
                                    <!--<th class="">
                                      Day1
                                    </th>
                                    <th class="">
                                      Day2
                                    </th>
                                    <th class="">
                                      Day3
                                    </th>

                                    <th class="">
                                      Day4
                                    </th>

                                    <th class="">
                                      Day5
                                    </th>
                                    <th class="">
                                      Day6
                                    </th>-->
                                    <th>Details</th>
                                    <th></th>

                                    <th> Is Transferred</th>


                                  </tr>
                                </thead>

                                <tbody class="table-body">
                                  <tr *ngFor="let l of CurrentSingleWellCultureByCycleCodeController;let i = index">

                                    <td class="padding-top-0px padding-bottom-0px">{{i+1}}</td>

                                    <td class="padding-top-0px padding-bottom-0px">
                                      <div>DOC : {{GetMaxDOC(l)}} </div>
                                      <div>Well # : {{l.WellNo}}</div>
                                      <div>Ins.Tech : {{l.Technique}} </div>
                                      <div>Denuded : {{l.OocyteQualityPost}}</div>
                                    </td>



                                    <td class="padding-top-0px padding-bottom-0px">

                                      <div class="card border-all-1px nav-link-hand margin-bottom-0px">

                                        <div class="card-body  padding-bottom-0px padding-top-0px padding-left-0px">

                                          <div class="row margin-left-0px">
                                            <div>
                                              <label class="margin-left-3px">{{GetMaxGrade(l)}}</label>
                                            </div>
                                            <div>
                                              <img class="border-radius-50p nav-link-hand margin-top-10" height="35px" width="35px" [src]="l.Image1" onError="this.src='dummy.jpg';">
                                            </div>

                                          </div>


                                        </div>

                                      </div>

                                    </td>




                                    <td class="padding-top-0px padding-bottom-0px  padding-right-0px ">
                                      <!--<button (click)="SaveTransfered(l)" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new " *ngIf="!l.IsTransFerred">Confirm </button>-->
                                      <button (click)="SaveTransfered(l)" class="btn actions-btn-prime font-size-13px" *ngIf="!l.IsTransFerred">Confirm </button>
                                      <div class="row margin-left-0px margin-right-0px" *ngIf="l.IsTransFerred">
                                        <div class="col-md-1 padding-left-4">
                                          <i class="fas fa-check-circle color-icon-completed font-size-23px"></i>
                                        </div>
                                        <div class="col-md-10 padding-right-0px text-align-left">
                                          <label class="margin-bottom-0px">Is Transferred</label>
                                        </div>

                                      </div>
                                      <!--<div *ngIf="l.IsTransFerred">
                                        <i class="fas fa-check-circle color-icon-completed font-size-23px"></i>
                                        <label class="margin-bottom-0px">Is Transferred</label>
                                      </div>-->
                                      <!--<div class="row" *ngIf="l.IsTransFerred">

                                        <div *ngIf="l.IsTransFerred"><i class="fas fa-check-circle color-icon-completed font-size-23px"></i></div>
                                        <div *ngIf="l.IsTransFerred"><label class="margin-bottom-0px">Is Transferred</label></div>
                                      </div>-->

                                    </td>
                                  </tr>



                                </tbody>

                              </table>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="accordion" id="accordionExampletestnew">
                    <div class="card margin-bottom-5px">
                      <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingtestnew">
                        <div class="row">
                          <div class="col-md-4 col-4">
                            <h5 class="mb-0 height-24px">
                              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapsetestnew" aria-expanded="true" aria-controls="collapsetestnew">
                                Procedures/Tests
                              </button>
                            </h5>
                          </div>
                          <div class="col-md-8 col-7 padding-right-0px">
                            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                            <button type="button"
                                    class="btn  btn-sm drive-button3 background-primary border-all-secondary float-right" id="FileUpload" (click)="AddTests()"
                                    name="upload">
                              <i class="fas fa-plus font-size-11"></i>
                            </button>
                          </div>
                        </div>


                      </div>

                      <div id="collapsetestnew" class="collapse show" aria-labelledby="headingtestnew" data-parent="#accordionExampletestnew">
                        <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                          <div class="row">
                            <div class="col-11 padding-right-0px">
                              <div class="table-component table-tests">
                                <div class="table-responsive">


                                  <table class="table table-striped margin-left-zero width-50-new">

                                    <tbody class="table-body">

                                      <tr *ngFor="let l of CurrentIvfCycleTestByCodeController ; let RowIndex = index ">

                                        <!--<td class="padding-top-4px padding-bottom-4px ">{{l.Date | date:'MMM-dd-yyyy'}}</td>
                                        <td class="padding-top-4px padding-bottom-4px ">{{l.TestName}}</td>
                                        <td class=" padding-top-4px padding-bottom-4px ">{{l.Comments}}</td>-->
                                        <td class="padding-top-6px padding-bottom-4px padding-right-0px vertical-align-top">{{RowIndex+1}}</td>
                                        <td class="padding-top-4px padding-bottom-4px padding-left-0px">


                                          <div class="height-16px">
                                            <label class="font-size-14 margin-bottom-0px">{{l.TestName}}</label>
                                          </div>
                                          <div class="row-height-17px">
                                            <label class="font-size-12px margin-bottom-0px">Result : {{l.Result}}{{l.ResultUnits}}</label>
                                          </div>
                                          <div class="row-height-17px">
                                            <label class="font-size-12px margin-bottom-0px">{{l.Comments}}</label>
                                          </div>
                                        </td>
                                        <td class="padding-top-4px padding-bottom-4px">
                                          <!--<a class="nav-link-hand education-navlink margin-right-10px " title="Edit">
                                            <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
                                          </a>-->
                                          <div class="test-icons float-right">
                                            <a (click)="delTEST(l)" title="Remove" *ngIf="!SelectedpatientDetails.IsReadyForPickup"><i class="fa fa-times color-Rejected delete-test-icon nav-link-hand"></i></a>
                                            <!--<a (click)="EditTest(l)" class="nav-link-hand education-navlink  color-Assign editicon edit-test-icon" title="Edit">
                                              <span class="badge"><i class="fas fa-pencil-alt"></i></span>
                                            </a>-->
                                          </div>
                                        </td>




                                      </tr>

                                    </tbody>
                                  </table>

                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="accordion" id="accordionExamplemedicinenew">
                    <div class="card margin-bottom-5px">
                      <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingmedicinenew">
                        <div class="row">
                          <div class="col-md-4 col-4">
                            <h5 class="mb-0 height-24px">
                              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapsemedicinenew" aria-expanded="true" aria-controls="collapsemedicinenew">
                                Medicines
                              </button>
                            </h5>
                          </div>
                          <div class="col-md-8 col-7 padding-right-0px">
                            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                            <button type="button"
                                    class="btn  btn-sm drive-button3 background-primary border-all-secondary float-right" id="FileUpload" (click)="AddMedicine()"
                                    name="upload">
                              <i class="fas fa-plus font-size-11"></i>
                            </button>
                          </div>
                        </div>


                      </div>

                      <div id="collapsemedicinenew" class="collapse show" aria-labelledby="headingmedicinenew" data-parent="#accordionExamplemedicinenew">
                        <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                          <div class="row">
                            <div class="col-11 padding-right-0px">
                              <div class="table-component">
                                <div class="table-responsive">


                                  <table class="table table-striped margin-left-zero width-50-new">
                                    <!--<thead>
                                                                        <tr>
                                                                          <th class="font-weight-normal  background-primary padding-left-4 padding-right-4 th-width-40px padding-top-4px padding-bottom-4px"></th>
                                                                          <th class="font-weight-normal  background-primary padding-left-4 padding-right-4 padding-top-4px padding-bottom-4px">

                                                                          </th>

                                                                          <th class="font-weight-normal  background-primary padding-left-4  padding-top-4px padding-bottom-4px">

                                    </th>
                                    <th class="font-weight-normal  background-primary padding-left-4  padding-top-4px padding-bottom-4px">

                                    </th>
                                    <th class="font-weight-normal  background-primary padding-left-4  padding-top-4px padding-bottom-4px">

                                    </th>


                                                                          <th class="font-weight-normal  background-primary padding-top-4px padding-bottom-4px">

                                                                          </th>











                                                                        </tr>
                                                                      </thead>-->
                                    <tbody class="table-body">

                                      <tr *ngFor="let l of CurrentIvfCycleMedicineByCodeController ; let RowIndex = index ">
                                        <td class="padding-top-4px padding-bottom-4px padding-top-6px vertical-align-top">{{RowIndex+1}}</td>
                                        <!--<td class="padding-top-4px padding-bottom-4px padding-left-0px">
                                          <div class="height-16px" >
                                            <label class="font-size-14 margin-bottom-0px">{{l.MedicineName}}</label>
                                          </div>
                                          <div class="height-16px" >
                                            <label class="font-size-12px margin-bottom-0px">{{l.Dose}}</label>
                                          </div>
                                          <div class="height-16px" >
                                            <label class="font-size-12px margin-bottom-0px">{{l.DosageForm}}</label>
                                          </div>
                                          <div class="height-16px" >
                                            <label class="font-size-12px margin-bottom-0px">{{l.Instructions}}</label>
                                          </div>
                                          <div class="height-16px" >
                                            <label class="font-size-12px margin-bottom-0px">{{l.Remarks}}</label>
                                          </div>

                                        </td>-->
                                        <td class="padding-top-4px padding-bottom-4px padding-left-4"><label class="font-size-12px margin-bottom-0px">{{l.MedicineName}}</label></td>

                                        <td class=" padding-top-4px padding-bottom-4px ">{{l.Dose}}</td>
                                        <td class=" padding-top-4px padding-bottom-4px padding-left-4">{{l.DosageForm}}</td>
                                        <td class=" padding-top-4px padding-bottom-4px ">{{l.Instructions}}</td>

                                        <td class="padding-top-4px padding-bottom-4px ">
                                          <div class="test-icons">
                                            <a class="float-right" (click)="delMedicine(l)" title="Remove" *ngIf="!SelectedpatientDetails.IsReadyForPickup"><i class="fa fa-times color-Rejected nav-link-hand"></i></a>
                                            <!--<a (click)="EditMedicine()" class="nav-link-hand education-navlink  color-Assign" title="Edit">
                                              <span class="badge"><i class="fas fa-pencil-alt"></i></span>
                                            </a>-->
                                          </div>
                                        </td>
                                        <!--<td class="padding-top-4px padding-bottom-4px">


                                        </td>-->




                                      </tr>

                                    </tbody>
                                  </table>

                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>




                </div>

              </div>


            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
  <div class="row" *ngIf="Showivf">
    <div class="col-md-12">
      <ivfworkbench></ivfworkbench>
    </div>
  </div>

  <router-outlet></router-outlet>
  <router-outlet name="print"></router-outlet>
</div>
